
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as asko6C20YpT8tWiSpB0CyQx3DuvMkG3w_krcBqw6rhQvccMeta } from "/usr/src/app/pages/ask.vue?macro=true";
import { default as uaeRqFbqtzfKv8PgH_zo50p96jnNAEjGDi9IIz8EE94s64Meta } from "/usr/src/app/pages/uae.vue?macro=true";
import { default as helpaR7WYl0CbI_k6WBPOidHpTZMT6f87QeJfTaC_DnA3NIMeta } from "/usr/src/app/pages/help.vue?macro=true";
import { default as joinOb7ZkY2JKMCW5r5yWgvTDiUAVoo6HEhA2Qrc_45CVFzJ4Meta } from "/usr/src/app/pages/join.vue?macro=true";
import { default as newsTZojyIwi15jSCDdDLKZccDzEoNgyhNpHAwWngsAc0qEMeta } from "/usr/src/app/pages/news.vue?macro=true";
import { default as deals0takiZyC8HsAhNvhZRWo1duuah4_J6BSFAVC4mohcrcMeta } from "/usr/src/app/pages/deals.vue?macro=true";
import { default as indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as learnvZ_9f7oz_45rHHMb3HyVQ1o9D_Ixffr0QuLn3a5FWiQssMeta } from "/usr/src/app/pages/learn.vue?macro=true";
import { default as terms3rROAvYViDKNcKOwISJDFnxdu54aezBGpts8Ftp9DkAMeta } from "/usr/src/app/pages/terms.vue?macro=true";
import { default as offersbdumaI__AFdBLT9nbCzdV7qjG9Lw40YpQ95PZkIFMXwMeta } from "/usr/src/app/pages/offers.vue?macro=true";
import { default as resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta } from "/usr/src/app/pages/resale.vue?macro=true";
import { default as contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta } from "/usr/src/app/pages/contact.vue?macro=true";
import { default as explorepLxqUFyuGEXsktl3Qvs52GfK_45XGagppMpqfHX9D36rkMeta } from "/usr/src/app/pages/explore.vue?macro=true";
import { default as privacyu2J_45fpQQL_Dgn_sGlidggdWkxxjogPaqND_45nTe41_csMeta } from "/usr/src/app/pages/privacy.vue?macro=true";
import { default as dealsjREtN7pA2wuNteJ0XtkeCMe5EluzJR15zhs_s9UxalMMeta } from "/usr/src/app/pages/am/deals.vue?macro=true";
import { default as loginfoZ38QbRkupQcV6AXjs44IXhN9bzsiH5jCysBRvPiikMeta } from "/usr/src/app/pages/am/login.vue?macro=true";
import { default as team_45nv8tVjsbeCCGeQCydZftD0waKjinQabGq7189W2OUcMeta } from "/usr/src/app/pages/b2b/team.vue?macro=true";
import { default as _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta } from "/usr/src/app/pages/p/[slug].vue?macro=true";
import { default as rankingsUEPoehRASzZ9fqkZ_kEjwjKHQJT1_GADQztSEOM4DVgMeta } from "/usr/src/app/pages/rankings.vue?macro=true";
import { default as registermVjICC6ssMl1WP_453_45hCWCcFBcUapUwtxJEvEeNH5zCkMeta } from "/usr/src/app/pages/register.vue?macro=true";
import { default as indexkn8UdRuwcD1OxlXAvpdDEZZqvxRJc13PgIBC98MH97gMeta } from "/usr/src/app/pages/b2b/index.vue?macro=true";
import { default as dashboardUiWW5Rllx_45TsV7mUA4ADpq_45XIaBErJurYnh1mwOoY9YMeta } from "/usr/src/app/pages/dashboard.vue?macro=true";
import { default as referralsi7cJDsYwC8f0m_aSAPHNydI8dX8bHG68ASfZiXxSCIMMeta } from "/usr/src/app/pages/referrals.vue?macro=true";
import { default as verify_45idr9mq1J3JynoJh23kqgXt4dlUep9X6yhOWcorKgAvj8kMeta } from "/usr/src/app/pages/verify-id.vue?macro=true";
import { default as loginbhfnU9x7MR7m12v0KzbzVvYjJ3pYqfBgGLOrjb6fFm8Meta } from "/usr/src/app/pages/auth/login.vue?macro=true";
import { default as indexM4aIjZXYnOMn7_pUWXKGNemIwrEbJS8fX4hIac5kgFYMeta } from "/usr/src/app/pages/eval/index.vue?macro=true";
import { default as loginMgzjaGgnC9GoieD0ZJnJGPHkrvey7DkfFj8wnY_45EtL0Meta } from "/usr/src/app/pages/eval/login.vue?macro=true";
import { default as auto5d8ZbmukqbIHz47QrUXybygU_4583m0xB9KxYJijK5adEMeta } from "/usr/src/app/pages/login/auto.vue?macro=true";
import { default as pre_45launchKf647MfxP1FD46lOwU32HOb_45ztOl7JKs7fJ5EQZuRn4Meta } from "/usr/src/app/pages/pre-launch.vue?macro=true";
import { default as sent98FS9DHgwHjyrdw17oOYeldfzOCOmRAP2p67Niq0fMUMeta } from "/usr/src/app/pages/reset/sent.vue?macro=true";
import { default as indexxAj_S_aU2eajuruoV_IIBtciDayaqwXb64PvFxNUxSYMeta } from "/usr/src/app/pages/saas/index.vue?macro=true";
import { default as indexheIeQbzM9wLVSuMwWpaQiLiL4W4bdha841uk8k5lUScMeta } from "/usr/src/app/pages/admin/index.vue?macro=true";
import { default as loginugK_45_45xIUOdULpo6UpztH9kvQegixIZjqKlgmmQAwKZ4Meta } from "/usr/src/app/pages/admin/login.vue?macro=true";
import { default as billingfY_45SD05NpPjnx_45xnzZOjqChd5pW8X_Kl8NiepAHVWVYMeta } from "/usr/src/app/pages/b2b/billing.vue?macro=true";
import { default as leaderboarddc0O2ZdE8cToW6HWW7xn_c0McP8LQ8DwBm8YRX1iRgEMeta } from "/usr/src/app/pages/leaderboard.vue?macro=true";
import { default as check1Xy4ccf0hYXa8Ezrz_45uR1Rg9TN6dC_45Z3JGjTelZ0AdkMeta } from "/usr/src/app/pages/login/check.vue?macro=true";
import { default as emailVgWhkF_oGlQrCir_kVdxc0LXIudB5n_a5XRILnAaWP8Meta } from "/usr/src/app/pages/login/email.vue?macro=true";
import { default as indexDKVd05MLJnFC29f0eB5ZuesuyGzzyi_7ngIkziaq_H8Meta } from "/usr/src/app/pages/login/index.vue?macro=true";
import { default as telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta } from "/usr/src/app/pages/lp/telegram.vue?macro=true";
import { default as indexONzPk2pV0BIwSdmomNoqz16XFtTc1USXtnXyXb6NOnYMeta } from "/usr/src/app/pages/reset/index.vue?macro=true";
import { default as add_45propertyFwqoOpKq1sFRLrloKQSiL9slDNYCWVjE8GRKfp2xy64Meta } from "/usr/src/app/pages/add-property.vue?macro=true";
import { default as funneleHgACeKKBbSzouaAXjpbgwGpHxgs3rCD4yvKdHl85EEMeta } from "/usr/src/app/pages/admin/funnel.vue?macro=true";
import { default as indexi6ygyqnVg3LQyTtauvOef5bulAKzajDVGnfObzI2iI8Meta } from "/usr/src/app/pages/agency/index.vue?macro=true";
import { default as indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta } from "/usr/src/app/pages/agents/index.vue?macro=true";
import { default as dashboardJfzSl4jRcPqLPbH5r5_45MPqx93j5lbysEwSnWEi0dtWEMeta } from "/usr/src/app/pages/am/dashboard.vue?macro=true";
import { default as indexaVFxYvJu8ymaQjV0tUcccM95djaR9fqpSKr1qMIUfXIMeta } from "/usr/src/app/pages/am/uae/index.vue?macro=true";
import { default as appointments_EvsN9DU1g38s9uTWmoh5RAA3lTLbT8x_yTkXQbOzRQMeta } from "/usr/src/app/pages/appointments.vue?macro=true";
import { default as _91id_93ikHy5H2Rt0goctTYL3b0IRUxjYcM2wCOQGc095ZPdX0Meta } from "/usr/src/app/pages/go/user/[id].vue?macro=true";
import { default as verifybRvHgKfRMtSLeRuk69LDxDG6dg8YM0qjqZzDqCixH3UMeta } from "/usr/src/app/pages/login/verify.vue?macro=true";
import { default as teamF4NRK08l4bcvHaPB4ooEONThDJSncKt9yvvrJ5IHSTQMeta } from "/usr/src/app/pages/profile/team.vue?macro=true";
import { default as _91token_93VuWnz5FmtSh6HqWOI9FGzm9HNi5rjhXQXXuOLv2eP14Meta } from "/usr/src/app/pages/sign/[token].vue?macro=true";
import { default as emailLUiM_R7KsS3p3YIFMuQ4l7TSkUbDcVSbUk_jj07lQYMMeta } from "/usr/src/app/pages/signup/email.vue?macro=true";
import { default as indexiYfC9AJ3VhIIva16wasaFSQz5iNu1lgdA4IllRk6WaQMeta } from "/usr/src/app/pages/signup/index.vue?macro=true";
import { default as _91slug_93pMiqqKcVyTAEDnDGsBLcRjMOEPMNc9ZklyC8moS17agMeta } from "/usr/src/app/pages/vault/[slug].vue?macro=true";
import { default as billingxh1qw_PzYXlluXyR_p4vx7zAKk9by0bM68SX4U1yey4Meta } from "/usr/src/app/pages/admin/billing.vue?macro=true";
import { default as id_45reviewsIfHI__45dB_45nKhJYYAItlwPk4L3Bgftz5Bt9jaVsxLgwsMeta } from "/usr/src/app/pages/am/id-reviews.vue?macro=true";
import { default as indexsx8ywn4Np9Denn1myGRxTuqWw92Onj72SpvD1iYzpOIMeta } from "/usr/src/app/pages/am/team/index.vue?macro=true";
import { default as continueFR2yhS_45hYuL2aP3Y6B_p9GAkaEhqdu90Q0UjCLhfh28Meta } from "/usr/src/app/pages/auth/continue.vue?macro=true";
import { default as registernPN_456HnqgsYNI4BuSoA30RxyPX_45hSTUN0NlsGUhK0JIMeta } from "/usr/src/app/pages/auth/register.vue?macro=true";
import { default as newzK9hjcMxxLl6T25BptEwcbMolDHHI_45SGQdRKhl0_45E6gMeta } from "/usr/src/app/pages/b2b/deals/new.vue?macro=true";
import { default as deals_45aa_45formRSHgorqfE7gi_MOx29Tb_45oL9__45_45Or4_Ep1M8CCae1N8Meta } from "/usr/src/app/pages/deals-aa-form.vue?macro=true";
import { default as international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta } from "/usr/src/app/pages/international.vue?macro=true";
import { default as indexbYjd0RM4EZ1JzoPM3R_45wkMbw25gILbSV5xClx0stGDYMeta } from "/usr/src/app/pages/profile/index.vue?macro=true";
import { default as _91id_93kb9bjXUZrWGs1qdGCw1Nz_S3pGR9bxgzON5Vj1hUH78Meta } from "/usr/src/app/pages/property/[id].vue?macro=true";
import { default as successS_DSly0hbmce4Nri2uByZmbbzgg1bz8Wm8sFLvr83fcMeta } from "/usr/src/app/pages/reset/success.vue?macro=true";
import { default as _91token_93XA13fZZUQSMTxgn9af4u0AmavhPfBWdJqWnUBTLySkIMeta } from "/usr/src/app/pages/share/[token].vue?macro=true";
import { default as _91id_93jpiq0evCwhC51WspIbGjGfgBeCmEtBLRo8DRDz6Pw04Meta } from "/usr/src/app/pages/b2b/deals/[id].vue?macro=true";
import { default as deals_45aa_45forms_cpcySQDno26zM4DJlAUONeFShqY3HFKADVCCF8jaSUMeta } from "/usr/src/app/pages/deals-aa-forms.vue?macro=true";
import { default as deals_45registerH6xoOccVVn__h_458SUgVh3ZyNwb3OaFqFvb_45sB8M5uHgMeta } from "/usr/src/app/pages/deals-register.vue?macro=true";
import { default as delete_45accountqfxtzETedZ1XcuyM7kCf5Db1Ck4mbOouYs4Znq21ejkMeta } from "/usr/src/app/pages/delete-account.vue?macro=true";
import { default as failedZMg6BTg5eaUIvnvn2Ox5cotVYqOUL8NtYdSiSHcpXjMMeta } from "/usr/src/app/pages/payment/failed.vue?macro=true";
import { default as passwordyZzfleCrhsGzlYQoMRwVUhstiasyDvmo1Ak2kL9FgjoMeta } from "/usr/src/app/pages/reset/password.vue?macro=true";
import { default as indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta } from "/usr/src/app/pages/services/index.vue?macro=true";
import { default as shared_45answerss30PNq1376MP0PO8QQIGDq4h4Ex7Z_454_45bqJa4GLsVjkMeta } from "/usr/src/app/pages/shared-answers.vue?macro=true";
import { default as contactiE3rLZl094u_JJl_6nbWUL0HFPdKn_jKxBtUnkjtDNAMeta } from "/usr/src/app/pages/signup/contact.vue?macro=true";
import { default as welcomejrpQs9yHWWP32lct_45KdlrhWb4BzrnSbWUWwsNfadyj8Meta } from "/usr/src/app/pages/signup/welcome.vue?macro=true";
import { default as index7FErS2FZdCc3nptG_45Y_zGgBG_45MgWkSKdFSIIDuuSCHYMeta } from "/usr/src/app/pages/training/index.vue?macro=true";
import { default as _91token_93ydpfSGSQAuHqp6VSz088oIxs03Xk6l7sWMhnluvw0YoMeta } from "/usr/src/app/pages/aa-sign/[token].vue?macro=true";
import { default as dashboardtx6deMYfoKD7h5QYabhFN0OMrIRPz18n3x86zBDRTDEMeta } from "/usr/src/app/pages/admin/dashboard.vue?macro=true";
import { default as indexOpvahcvGVxQTSBIG_45b6GNnHBfZbhSilv_45ffz0FUG8wsMeta } from "/usr/src/app/pages/admin/uae/index.vue?macro=true";
import { default as joinsqYTfJcD9CLu7knvZ3Kn78TYOlAq3tD_GwSEiZkRZgQYMeta } from "/usr/src/app/pages/admin/uae/joins.vue?macro=true";
import { default as indexcKQzYZF6GtgcSum3n_45CJ6C_4Z0i7DS7MY8Zcx_451utUsMeta } from "/usr/src/app/pages/am/agents/index.vue?macro=true";
import { default as newSKRHMfIP4POr2VLFBqwlthTTx7Pe1Z9qvoGNwrwz1vgMeta } from "/usr/src/app/pages/b2b/clients/new.vue?macro=true";
import { default as indexdmqlBNPmzWa0nNZS89yTrMgrvn3R729wBjTUHLnXFegMeta } from "/usr/src/app/pages/b2b/deals/index.vue?macro=true";
import { default as developer_45vaultwbHseQPF6YsXnS5DlKtd10_45m9UgH5PrRurBWywFB6wkMeta } from "/usr/src/app/pages/developer-vault.vue?macro=true";
import { default as applyW2fGsKaXzkWi4fWfgcpy1aFfx3KWd0DnnhgFSKTYH8EMeta } from "/usr/src/app/pages/developer/apply.vue?macro=true";
import { default as indexdjxqytI7DhHB_45qQPIkPTsmeJ1nOvvNZr_45BsfjUm7rNsMeta } from "/usr/src/app/pages/developer/index.vue?macro=true";
import { default as index44O1Uc8f_Kb3FgY1AYSdzT2v_45DJT5ZAToSbh0kPp96wMeta } from "/usr/src/app/pages/marketing/index.vue?macro=true";
import { default as successCihTq4DE_UGrltcjE_oG6FFh1yXlFZCRNTPi4pTSE4MMeta } from "/usr/src/app/pages/payment/success.vue?macro=true";
import { default as _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta } from "/usr/src/app/pages/properties/[id].vue?macro=true";
import { default as password76ZjmO5rQF8sYiBrWAzMljIFEjSgdamwkO8csEnrNpcMeta } from "/usr/src/app/pages/signup/password.vue?macro=true";
import { default as _91slug_93eh87CLWxF9zmzSb_45dC8z_45m70mhzBRBHZMggVyLas0nQMeta } from "/usr/src/app/pages/training/[slug].vue?macro=true";
import { default as indexBlnI5xY7gFHjJu8LGsrPxWP_45jRjpQb8TkkvpjIiJS1sMeta } from "/usr/src/app/pages/a/[handle]/index.vue?macro=true";
import { default as agentsML2hu0Qrv5YSR2TFu_j0Vq7vURP6YAbkcmnDS3uo8x4Meta } from "/usr/src/app/pages/admin/uae/agents.vue?macro=true";
import { default as managersC2nxVdLyf5fl3ZSNuXtuQDnuLzHlFVsDr3RSTDnG4SQMeta } from "/usr/src/app/pages/am/team/managers.vue?macro=true";
import { default as indexpZL9jQqY5UdFGmgJFVy4Hb7ebJz91COEQ82DNQQ_45534Meta } from "/usr/src/app/pages/auth/reset/index.vue?macro=true";
import { default as _91id_93vLdDZcWrKHPgc9X5M92yESLpKM60fgUcwOCSZzk7di4Meta } from "/usr/src/app/pages/b2b/clients/[id].vue?macro=true";
import { default as _91token_93FaJ8IQk4YudgnrsSeYsSGIVd71nyK9fgFoXFNf3fFnAMeta } from "/usr/src/app/pages/b2b/join/[token].vue?macro=true";
import { default as uae_45teamwRG0JW_45i9TPBgxWqvEhUHSZ1CWVjmWRKEDLf_pxMqHUMeta } from "/usr/src/app/pages/billing/uae-team.vue?macro=true";
import { default as indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta } from "/usr/src/app/pages/developers/index.vue?macro=true";
import { default as payments_45historyQJi8UKBejqiINvOKcUKQgaKLCPj3gCLtlZF95qdm4kMMeta } from "/usr/src/app/pages/payments-history.vue?macro=true";
import { default as indexZLYQ8fDwPFkWNtKloeYk5uEnQbR3BebLOi0lL_hIQEAMeta } from "/usr/src/app/pages/admin/users/index.vue?macro=true";
import { default as _91id_93K75xXEqre98HlN_G3Pk5AzRgV1g9Y0k3Saa11XGOhrAMeta } from "/usr/src/app/pages/am/campaigns/[id].vue?macro=true";
import { default as indexHOLpEhYvGHxTHWio9si_45VD3rdVZG6o057G1LbRS2aDgMeta } from "/usr/src/app/pages/b2b/clients/index.vue?macro=true";
import { default as _91token_93gJ_45bhVeiYzv2mfBp14NdSWs1sRmGqZLpOjt8m5eO4T0Meta } from "/usr/src/app/pages/b2b/setup/[token].vue?macro=true";
import { default as deals_45aa_45form_45newgLFKNDdmsXXUtXi1_45IDBELewvGIK9N_45Rf2NwvWbm05kMeta } from "/usr/src/app/pages/deals-aa-form-new.vue?macro=true";
import { default as _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta } from "/usr/src/app/pages/developers/[slug].vue?macro=true";
import { default as unsubscribeuDlsUZYufuoLuS3oJcnnsLtTJkKBCSqMrRnf2lHBgGsMeta } from "/usr/src/app/pages/email/unsubscribe.vue?macro=true";
import { default as indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta } from "/usr/src/app/pages/masterclass/index.vue?macro=true";
import { default as learnnzeA_ywHGo_45w_znTVN_oRTB0LTAm8YXbcLx5qdb7_FIMeta } from "/usr/src/app/pages/masterclass/learn.vue?macro=true";
import { default as loginh4MSQqIHg5xN7lwSHC0tvdh6qHA30ZKZCxcEqKajXYMMeta } from "/usr/src/app/pages/masterclass/login.vue?macro=true";
import { default as startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta } from "/usr/src/app/pages/masterclass/start.vue?macro=true";
import { default as indexuogMiTNn_DqazL6bsM90b3I3F9EKWcAsHCvo_45rYZs6oMeta } from "/usr/src/app/pages/my-services/index.vue?macro=true";
import { default as abandonedbuKhM7UJnAtKWJFZUytwX0UKRUzTmuvKRTLUxoQVmxAMeta } from "/usr/src/app/pages/payment/abandoned.vue?macro=true";
import { default as indexokcMVH0CKxtcvLltk0HIDp3_5olfCVZZHAMLUigibLEMeta } from "/usr/src/app/pages/admin/agents/index.vue?macro=true";
import { default as integrationsSK37QOQinI7MGlQZ0XvXxL9iTa0j3CS6DAlvNP9hoHMMeta } from "/usr/src/app/pages/admin/integrations.vue?macro=true";
import { default as settingsw87RHY_uD67S12o7MTz9U65_45tsGBGi4opLqFdSoLamYMeta } from "/usr/src/app/pages/admin/uae/settings.vue?macro=true";
import { default as registerZQrEBv1YgF1bYQMPnyH96SjHJltb_tgoDP2ofarMMlUMeta } from "/usr/src/app/pages/am/agents/register.vue?macro=true";
import { default as indexuSVT_45C4CUFOyy8ou4ptP1QmMBiLVUszoV4EsYg4THFsMeta } from "/usr/src/app/pages/am/campaigns/index.vue?macro=true";
import { default as newiJOVjeoSscWLHQeRrb5bvnVqF9LKill5p5d7UgFuUvcMeta } from "/usr/src/app/pages/developer/news/new.vue?macro=true";
import { default as overviewe8CnlrT0djJSfL4kH3FWOc7c8gOmB0c_uR4w5pXHf64Meta } from "/usr/src/app/pages/developer/overview.vue?macro=true";
import { default as settingsAKToVo_2jXhlytOaQwoRPQ3BkkVC_45fUp3StaB0Il_V0Meta } from "/usr/src/app/pages/developer/settings.vue?macro=true";
import { default as _91slug_93y1Y1KV11DNSF8Nb_45tmou590GQZvxNDSPbc_45hINX2NOMMeta } from "/usr/src/app/pages/my-services/[slug].vue?macro=true";
import { default as thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta } from "/usr/src/app/pages/services/thank-you.vue?macro=true";
import { default as _91id_93nWqri_45r9Pb_45B5jpVmzBjISXY7hlJKZCml6NPLCZWDQ8Meta } from "/usr/src/app/pages/admin/agencies/[id].vue?macro=true";
import { default as _91id_93unlNT8JnDVHxXuwudC5utfpOyEX_45R1lThhDnrmuGGb4Meta } from "/usr/src/app/pages/admin/packages/[id].vue?macro=true";
import { default as index_45TDrQ7tdxssho3ssGYo5bJGg8SNxv5PICsq77Miq0YEMeta } from "/usr/src/app/pages/admin/payouts/index.vue?macro=true";
import { default as _91id_9324RLyENccp0kuLN3IsquBdrfh3TbdaowW1W76zs8eisMeta } from "/usr/src/app/pages/admin/services/[id].vue?macro=true";
import { default as _91id_937GLCTrFVlNhLfBDVPtfcS6QLIBaclb5_M77lUu3naNAMeta } from "/usr/src/app/pages/admin/training/[id].vue?macro=true";
import { default as passwordFgz6F8_jyP38Q1ArYRR6C9wfvnJyxCsUwYNpT626Iz8Meta } from "/usr/src/app/pages/auth/reset/password.vue?macro=true";
import { default as _91code_9364moMHt7OhnoBqLOkPF48ceyTxU70h1ZN0B_45jVX_VRQMeta } from "/usr/src/app/pages/certificates/[code].vue?macro=true";
import { default as deals_45register_45pathUXZ4rOkHxlmcYkTTq5gNa77FYxMTTlicEDcGVTZtrK0Meta } from "/usr/src/app/pages/deals-register-path.vue?macro=true";
import { default as _91id_930IwbIebnPmm58Filbe3C5mFFi5LDyb9JWlbY8b9U6iwMeta } from "/usr/src/app/pages/developer/news/[id].vue?macro=true";
import { default as indexIWKRTXVS4i8_S5d1f_45xiFGJrFVshtGRfrNUFP4IAPMkMeta } from "/usr/src/app/pages/admin/agencies/index.vue?macro=true";
import { default as _91id_93FhUxFNaKDcQXyTzTjKv323g61TGkjqsx2tB7CcedTbUMeta } from "/usr/src/app/pages/admin/b2b-deals/[id].vue?macro=true";
import { default as _91id_93PoYyhtTmRW3misi38kR8F_454y3iGvGTH_Y6pgS0YgO0IMeta } from "/usr/src/app/pages/admin/campaigns/[id].vue?macro=true";
import { default as indexp9M2HIAmvBUyWLQ6eYEWlTX8Dl_Dfxryg6YmqVk3a9kMeta } from "/usr/src/app/pages/admin/packages/index.vue?macro=true";
import { default as indexubsmO1lDtgO_45SdOx3iA_OcqEzDcRuUV8w2yqrcu_457fgMeta } from "/usr/src/app/pages/admin/projects/index.vue?macro=true";
import { default as indexEBWTFfEKoZAv1rhzjWBzKro4uWRUW8qhOTag4xPj1cMMeta } from "/usr/src/app/pages/admin/services/index.vue?macro=true";
import { default as indexNx5rXMS8CTJa5FmWIUSLZiCQwkDtBOh2k9rlwzY9KPUMeta } from "/usr/src/app/pages/admin/training/index.vue?macro=true";
import { default as id_45reviewsOrNyB0uC_182OG4hhi9Ce2COh8MzpYivJckCykyB5o0Meta } from "/usr/src/app/pages/admin/uae/id-reviews.vue?macro=true";
import { default as service_45referralsQ9qnuDTzPmTWNu16tn9QTgwBZZTY604wfYgH2sIhOygMeta } from "/usr/src/app/pages/am/service-referrals.vue?macro=true";
import { default as indexq46dzVm36_4JpueEJ1VvBTo43u5S_45THoSEn6XNoRMxIMeta } from "/usr/src/app/pages/developer/news/index.vue?macro=true";
import { default as checkout9EoD5npkEPKvvVBZ4MiC8RVFnaGfMQ55MF_CXG9iVEEMeta } from "/usr/src/app/pages/my-services/checkout.vue?macro=true";
import { default as indexm2w_ZtvYNf49Bl0VqUdBW4n1kvZyWAhhw7SmufLlP4MMeta } from "/usr/src/app/pages/admin/b2b-deals/index.vue?macro=true";
import { default as indexObqkzPaje4QZCScH1tbXDvwYpHVHxbeEHwV6cLEevKYMeta } from "/usr/src/app/pages/admin/campaigns/index.vue?macro=true";
import { default as hidden_45projects_sPPq2rAbzSbwlIu6JOTyCNzo_45PyVnTC3tSQ_45IA8QgIMeta } from "/usr/src/app/pages/admin/hidden-projects.vue?macro=true";
import { default as createKgl0UaLfqhle0SWKc0Er9_453IL6CikifD2KyJROehzigMeta } from "/usr/src/app/pages/admin/packages/create.vue?macro=true";
import { default as indexWnTQoJMMuhQFDR_45UOb3MmSIDBLwK8fBU_nwbQrv9sisMeta } from "/usr/src/app/pages/admin/portfolio/index.vue?macro=true";
import { default as resale_45listingsMXjeukkGkm16iHURHXx4q_45PhUTYHBIken7EzY8FP_45aMMeta } from "/usr/src/app/pages/admin/resale-listings.vue?macro=true";
import { default as createJOMwe_jqlWz45vn00sdNfzVa4WWrmahGbpTlDC33_45_YMeta } from "/usr/src/app/pages/admin/services/create.vue?macro=true";
import { default as created29qSRyZK76XezIGz8Q4OXIUdFF4L3k2eTlWd8w72GMMeta } from "/usr/src/app/pages/admin/training/create.vue?macro=true";
import { default as _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta } from "/usr/src/app/pages/masterclass/[variant].vue?macro=true";
import { default as indexNMKf08aXmqUIAPD9ltH9Ty3y11HxUl_45W7FOKz10IC9YMeta } from "/usr/src/app/pages/property/[hash]/index.vue?macro=true";
import { default as indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta } from "/usr/src/app/pages/services/[slug]/index.vue?macro=true";
import { default as indexgjv_45jTV_455l9UqduRxt1LQCS45OaMNZl09uDS6FSYnScMeta } from "/usr/src/app/pages/admin/activation/index.vue?macro=true";
import { default as payoutsnR2OwzvSvmMKf5amCIryqGcsbAhu0g7PojR4DUIfObQMeta } from "/usr/src/app/pages/admin/agencies/payouts.vue?macro=true";
import { default as newHl0d8Hv_45mIX9sn2tZ47C49YtUBGQl8x7NmR4qj6lBikMeta } from "/usr/src/app/pages/admin/b2b-agencies/new.vue?macro=true";
import { default as indexZq262dbaDFieJ4ZkpyVCvzLDQMQIgZP4uJkO3DuW4vYMeta } from "/usr/src/app/pages/admin/exclusives/index.vue?macro=true";
import { default as resale_45enquiriesQRKDdH8UY1nwaJI8tjThl7H5ysUsodxhSXw6DvG8jBgMeta } from "/usr/src/app/pages/admin/resale-enquiries.vue?macro=true";
import { default as service_45settingsyw9_45egotmvjR84qoK_45o9YZq_aWnwpqP0uyKleF_45ZgnoMeta } from "/usr/src/app/pages/admin/service-settings.vue?macro=true";
import { default as _91id_93YEqOVviuo6hA5vT8aMZxU9JvFZYwkZhKauXGkHXLHeUMeta } from "/usr/src/app/pages/am/service-orders/[id].vue?macro=true";
import { default as distributionodIC7_45_45IHhx2u_9I4b6uhMWAWw5xzBw8_PbBapZIRrQMeta } from "/usr/src/app/pages/developer/distribution.vue?macro=true";
import { default as newX_p4ngwLDpf_45HHkH1oe3DvOzHOOgV7ZvBCO7NuM6AtMMeta } from "/usr/src/app/pages/developer/projects/new.vue?macro=true";
import { default as onboardingXOAs0Revoedgmkv2iJaRogawXXuo3rs4ne8eocxgBG4Meta } from "/usr/src/app/pages/masterclass/onboarding.vue?macro=true";
import { default as agent_45phoneODAvhN2kgU0S0hq8JUEs2rtlFyfaBifyXiyxOtZb98sMeta } from "/usr/src/app/pages/onboarding/agent-phone.vue?macro=true";
import { default as submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta } from "/usr/src/app/pages/services/[slug]/submit.vue?macro=true";
import { default as account_45deletionsNBo41609QFeFG0aMiiy5hT_45TUyFGD7wFaQ5Ud5zT_45VcMeta } from "/usr/src/app/pages/admin/account-deletions.vue?macro=true";
import { default as settingskvUQvLCHbYRFZz36gN2ZUk6iGmyPtsRdJs5ff6p24xIMeta } from "/usr/src/app/pages/admin/agencies/settings.vue?macro=true";
import { default as indexwA5gP9GtQ69TH0oSBKRJicG0GePJyhjEBTC5sFEFOOMMeta } from "/usr/src/app/pages/admin/agent-deals/index.vue?macro=true";
import { default as _91id_932UyKTHbKeVPdP5yrhrGpsL8uE2OPX2qZkajhdTaPCW4Meta } from "/usr/src/app/pages/admin/b2b-agencies/[id].vue?macro=true";
import { default as indexXphsBCVVCXQ_45RexibN5Dqjwtx0CLPEIbc1TeLBY0Q4oMeta } from "/usr/src/app/pages/admin/b2b-payouts/index.vue?macro=true";
import { default as index7vDHnznT_8MI1pz_45GTKZlg6hYUt4OGshmOJ3SjRZP_8Meta } from "/usr/src/app/pages/admin/masterclass/index.vue?macro=true";
import { default as log1lPkpIrYpyGEpYyyDQTBLdN375SKYFP2nPl16DePg9wMeta } from "/usr/src/app/pages/admin/notifications/log.vue?macro=true";
import { default as scrapingPLrKIdjNbRfVsRKJlnf55w2n9W31JlsGaUBKMRlpgq8Meta } from "/usr/src/app/pages/admin/security/scraping.vue?macro=true";
import { default as service_45referralsZKttKhiKw0OlEYNDM6fhCchLzpY_45iH4_458pMViVBIG64Meta } from "/usr/src/app/pages/admin/service-referrals.vue?macro=true";
import { default as indexp7wxBYjwawSMsQ_45EA3gu5JHbvUkk_mQHUp5CJQzjPIwMeta } from "/usr/src/app/pages/am/service-orders/index.vue?macro=true";
import { default as _91id_93o_68hyu2yfYqdd7fR4H1_wWiXEo4vzCKJ7ASJThsHkUMeta } from "/usr/src/app/pages/developer/projects/[id].vue?macro=true";
import { default as _91id_93LjRlNeU8_45womFDz3E3JJAVKIsLb8pXG4Vo2tn2O7d3YMeta } from "/usr/src/app/pages/my-services/orders/[id].vue?macro=true";
import { default as _91token_93dbIF_45974JEHvn7pQV9beDt9zM3lrhaCJ7ozj7GkwMNYMeta } from "/usr/src/app/pages/my-services/pay/[token].vue?macro=true";
import { default as _91projectSlug_93eBRD5XwyY3S9hVpuz1r1tdPDT7wDmTLKK3aW82by2ooMeta } from "/usr/src/app/pages/a/[handle]/[projectSlug].vue?macro=true";
import { default as index7yE3ct0wOkGp6E5ItVQEucuZD7XEIwKG8fYQ_45PE9jxMMeta } from "/usr/src/app/pages/admin/b2b-agencies/index.vue?macro=true";
import { default as indexWiQXcPS3ok1Q1Wb688J9DONnMKnV2iAKltnCoGjeHRYMeta } from "/usr/src/app/pages/developer/projects/index.vue?macro=true";
import { default as indexIU8xSjCy1nJAWqGIUyJbWFLAoFqKzROqSiNeVMys9IgMeta } from "/usr/src/app/pages/admin/notifications/index.vue?macro=true";
import { default as _91id_93StSXMwxmNMEUAnHBGtapfLUa1x7tIykaf9MUxQaIEO4Meta } from "/usr/src/app/pages/admin/service-orders/[id].vue?macro=true";
import { default as deals_45register_45consultant9Vm21QFRyCVEeWxcoARZ9Siq8AAifnJ7NqCrgUUymkAMeta } from "/usr/src/app/pages/deals-register-consultant.vue?macro=true";
import { default as deals_45register_45self_45closeAke_ETW22JRpZYcPI3IyU3oKuhugpPps_lsxzQCIPhcMeta } from "/usr/src/app/pages/deals-register-self-close.vue?macro=true";
import { default as _91id_93jtdljeQubUjMUVpJmE_45JYnzzxWU2bKLuJfrZ_453AsgxYMeta } from "/usr/src/app/pages/property/[hash]/unit/[id].vue?macro=true";
import { default as submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta } from "/usr/src/app/pages/services/[slug]/submitted.vue?macro=true";
import { default as index5kdic0zCrm64Wpm5Ujx5v6Q9tw5lEPkNwKth5IqDfEEMeta } from "/usr/src/app/pages/admin/service-orders/index.vue?macro=true";
import { default as deals_45register_45spa_45confirmcppE4UUl7f1umQppKzFakgDpV2tqa0kIDG36oA3nDB8Meta } from "/usr/src/app/pages/deals-register-spa-confirm.vue?macro=true";
import { default as deals_45register_45spa_45pendingwwrCpv8AYW8pDJoM7LqCS_457ppBoDVBZw1t_45wAGwWAp0Meta } from "/usr/src/app/pages/deals-register-spa-pending.vue?macro=true";
import { default as index_45AQLQIi5l8rwdOs4q40nuEg0VUPSCz62H8DAvlmy0o0Meta } from "/usr/src/app/pages/admin/agent-referrals/index.vue?macro=true";
import { default as _91key_93gHriwPoQoV475LrXyy_eq3pUIYxuqogZI9CVicQD7_8Meta } from "/usr/src/app/pages/admin/email-templates/[key].vue?macro=true";
import { default as indexsCiV5WBpnk9gwZzEr2q2qUW_93cIWCs3bnOkG_45V1Vk0Meta } from "/usr/src/app/pages/admin/email-templates/index.vue?macro=true";
import { default as deals_45register_45booking_45formmVIgg5qQwmvUrDV_bxSWkT2UcVbF_45QT2XInQTMbAgU0Meta } from "/usr/src/app/pages/deals-register-booking-form.vue?macro=true";
import { default as deals_45register_45token_45uploadxgSC4ieGoCrvmQD4WVaUpwrdcRYvPMnwfBF1rEEuuk4Meta } from "/usr/src/app/pages/deals-register-token-upload.vue?macro=true";
import { default as newnaI4FQrLZb_btGD3hp7egqSncmgFPHC8vxegsTsP17gMeta } from "/usr/src/app/pages/developer/presentations/new.vue?macro=true";
import { default as _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta } from "/usr/src/app/pages/projects/[developer]/[slug].vue?macro=true";
import { default as indexFMzC08L04OW4_hbssEzkrJzLSHpnhQDLsEMd5lKcNHcMeta } from "/usr/src/app/pages/admin/commission-tiers/index.vue?macro=true";
import { default as indexxg8mz0yFSDmAYdrq__45genIPfacdLK2EfLeA7fQN17REMeta } from "/usr/src/app/pages/admin/project-listings/index.vue?macro=true";
import { default as _91id_932xam0cKcrAPZq_45KuiSSdZGbPa50oObiIi7vMVnaVOKUMeta } from "/usr/src/app/pages/admin/service-catalogue/[id].vue?macro=true";
import { default as _91id_93LVoQ0nMUhlXVfQo_70tAAdTpGDRto5Wzr25V8f2MLaMMeta } from "/usr/src/app/pages/developer/presentations/[id].vue?macro=true";
import { default as indexlC_Ma16XlxerbRQeGngI9nhbDTw1wJ7NQahj64r7GjQMeta } from "/usr/src/app/pages/admin/agent-withdrawals/index.vue?macro=true";
import { default as _91id_93rfnhHlm8EI_45_45y68pQeghQ8biMVDapWQ9EwtwOA3Wn7UMeta } from "/usr/src/app/pages/admin/points-of-interest/[id].vue?macro=true";
import { default as indexkIPFQeSJtk60FlDhL_TtrmyT_wfmhywNJ6c5HkH4JKoMeta } from "/usr/src/app/pages/admin/service-catalogue/index.vue?macro=true";
import { default as index6vpa4mTNWkcudcnRJQeJ2FFhd4kg_TGNBCEpp3k33tUMeta } from "/usr/src/app/pages/developer/presentations/index.vue?macro=true";
import { default as indexckwSIJDnUWVmnxVboWbrLS2jif_45jQ6hff1kIMYwvkOsMeta } from "/usr/src/app/pages/admin/deal-registrations/index.vue?macro=true";
import { default as index8LqVpus7kRHbIPbder5vb4uMB49SVn7_45WFG6pABF1EEMeta } from "/usr/src/app/pages/admin/developer-partners/index.vue?macro=true";
import { default as indexOSiHbOo4UvRKAzmlILr0Qa0IaySLFN_45eF4ACoxpe8E0Meta } from "/usr/src/app/pages/admin/points-of-interest/index.vue?macro=true";
import { default as deals_45register_45token_45confirmedaYQVjt1H4Al_45efYJZo7kD5n3xteRAwWJ_45wkoVGdQqFYMeta } from "/usr/src/app/pages/deals-register-token-confirmed.vue?macro=true";
import { default as createvNpKohJR26couO2wn0bYY9ZF2yZMSshmmRYss4PluTQMeta } from "/usr/src/app/pages/admin/points-of-interest/create.vue?macro=true";
import { default as deals_45register_45booking_45confirmeds97W_BFmh9NhLUOnRXitzt0m1CE4R9IbRWtPJK9NfVsMeta } from "/usr/src/app/pages/deals-register-booking-confirmed.vue?macro=true";
import { default as activityZ0DwXYSCk01BUBrV_zBsjGWPeQQf9ODZ4wSr71HmPzQMeta } from "/usr/src/app/pages/admin/developer-partners/activity.vue?macro=true";
import { default as approvalsX1cYldj691PlFu0rkXHLC2tojdNE1eVb4C2LjXppwaMMeta } from "/usr/src/app/pages/admin/developer-partners/approvals.vue?macro=true";
import { default as _91id_93cibkadBjkEt9rSNUQqZexEbOp7BcH2A_jEW3u3mN2eAMeta } from "/usr/src/app/pages/admin/notifications/campaigns/[id].vue?macro=true";
import { default as indexrcBO0YAL9Esdjpwrw2rHy_XPPDbRvmG2UK0kSEMRaMcMeta } from "/usr/src/app/pages/admin/notifications/campaigns/index.vue?macro=true";
import { default as deals_45register_45commission_45countdownRP7dicfJAqYoizFl0fzW1g4jWe7DAP5bUfbX7UWXiPIMeta } from "/usr/src/app/pages/deals-register-commission-countdown.vue?macro=true";
import { default as deals_45register_45consultant_45confirmed5tb0zeU9VaidWR3zBpSvTdX1Btta9hoEiLjhvlNlw1QMeta } from "/usr/src/app/pages/deals-register-consultant-confirmed.vue?macro=true";
import { default as permissions3pfR5AbMFB_ojFMVWBR1CkRT4583r79qzmsLPnGuYOEMeta } from "/usr/src/app/pages/admin/developer-partners/permissions.vue?macro=true";
import { default as verification3PjI8M2exM28u4tj9jRYfdwAAJAbJMPSCSpcfpRPcLsMeta } from "/usr/src/app/pages/admin/developer-partners/verification.vue?macro=true";
import { default as indexj8mefSSAlY_TvjvETOzftZ7wmo5enIXL2RNKlGJlxpcMeta } from "/usr/src/app/pages/admin/platform-account-managers/index.vue?macro=true";
import { default as representativesKBBTDqvQc3BG9M5QVcOuEG3M6Rsfqia9lYs2DranvqQMeta } from "/usr/src/app/pages/admin/developer-partners/representatives.vue?macro=true";
import { default as component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta } from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g } from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "ask",
    path: "/ask",
    meta: { ...(asko6C20YpT8tWiSpB0CyQx3DuvMkG3w_krcBqw6rhQvccMeta || {}), ...{"middleware":["is-auth","is-agent","is-verified"],"i18n":false} },
    component: () => import("/usr/src/app/pages/ask.vue")
  },
  {
    name: "uae",
    path: "/uae",
    meta: { ...(uaeRqFbqtzfKv8PgH_zo50p96jnNAEjGDi9IIz8EE94s64Meta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/uae.vue")
  },
  {
    name: "help",
    path: "/help",
    meta: {"i18n":false},
    component: () => import("/usr/src/app/pages/help.vue")
  },
  {
    name: "join",
    path: "/join",
    meta: { ...(joinOb7ZkY2JKMCW5r5yWgvTDiUAVoo6HEhA2Qrc_45CVFzJ4Meta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/join.vue")
  },
  {
    name: "news",
    path: "/news",
    meta: { ...(newsTZojyIwi15jSCDdDLKZccDzEoNgyhNpHAwWngsAc0qEMeta || {}), ...{"middleware":["is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/news.vue")
  },
  {
    name: "deals",
    path: "/deals",
    meta: { ...(deals0takiZyC8HsAhNvhZRWo1duuah4_J6BSFAVC4mohcrcMeta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___he",
    path: "/he",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    meta: indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta || {},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "learn",
    path: "/learn",
    meta: { ...(learnvZ_9f7oz_45rHHMb3HyVQ1o9D_Ixffr0QuLn3a5FWiQssMeta || {}), ...{"middleware":["is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/learn.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: { ...(terms3rROAvYViDKNcKOwISJDFnxdu54aezBGpts8Ftp9DkAMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/terms.vue")
  },
  {
    name: "offers",
    path: "/offers",
    meta: { ...(offersbdumaI__AFdBLT9nbCzdV7qjG9Lw40YpQ95PZkIFMXwMeta || {}), ...{"middleware":["is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/offers.vue")
  },
  {
    name: "resale___en",
    path: "/resale",
    meta: { ...(resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/resale.vue")
  },
  {
    name: "resale___ar",
    path: "/ar/resale",
    meta: { ...(resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/resale.vue")
  },
  {
    name: "resale___he",
    path: "/he/resale",
    meta: { ...(resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/resale.vue")
  },
  {
    name: "resale___ru",
    path: "/ru/resale",
    meta: { ...(resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/resale.vue")
  },
  {
    name: "resale___zh",
    path: "/zh/resale",
    meta: { ...(resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/resale.vue")
  },
  {
    name: "resale___fr",
    path: "/fr/resale",
    meta: { ...(resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/resale.vue")
  },
  {
    name: "resale___de",
    path: "/de/resale",
    meta: { ...(resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/resale.vue")
  },
  {
    name: "resale___es",
    path: "/es/resale",
    meta: { ...(resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/resale.vue")
  },
  {
    name: "resale___it",
    path: "/it/resale",
    meta: { ...(resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/resale.vue")
  },
  {
    name: "resale___pt",
    path: "/pt/resale",
    meta: { ...(resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/resale.vue")
  },
  {
    name: "resale___tr",
    path: "/tr/resale",
    meta: { ...(resaleGj5dag78gWJdbbJkGVOBiUdcE_m_LU4FyWeTV93mV9IMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/resale.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    meta: contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta || {},
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "contact___ar",
    path: "/ar/contact",
    meta: contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta || {},
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "contact___he",
    path: "/he/contact",
    meta: contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta || {},
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "contact___ru",
    path: "/ru/contact",
    meta: contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta || {},
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "contact___zh",
    path: "/zh/contact",
    meta: contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta || {},
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "contact___fr",
    path: "/fr/contact",
    meta: contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta || {},
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "contact___de",
    path: "/de/contact",
    meta: contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta || {},
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "contact___es",
    path: "/es/contact",
    meta: contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta || {},
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "contact___it",
    path: "/it/contact",
    meta: contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta || {},
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "contact___pt",
    path: "/pt/contact",
    meta: contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta || {},
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "contact___tr",
    path: "/tr/contact",
    meta: contactNc0C5gLGaEbbKpHBM_45rlHhpMO0I0wWybi0ntpQFD50AMeta || {},
    component: () => import("/usr/src/app/pages/contact.vue")
  },
  {
    name: "explore___en",
    path: "/explore",
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "explore___ar",
    path: "/ar/explore",
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "explore___he",
    path: "/he/explore",
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "explore___ru",
    path: "/ru/explore",
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "explore___zh",
    path: "/zh/explore",
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "explore___fr",
    path: "/fr/explore",
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "explore___de",
    path: "/de/explore",
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "explore___es",
    path: "/es/explore",
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "explore___it",
    path: "/it/explore",
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "explore___pt",
    path: "/pt/explore",
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "explore___tr",
    path: "/tr/explore",
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: { ...(privacyu2J_45fpQQL_Dgn_sGlidggdWkxxjogPaqND_45nTe41_csMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/privacy.vue")
  },
  {
    name: "am-deals",
    path: "/am/deals",
    meta: { ...(dealsjREtN7pA2wuNteJ0XtkeCMe5EluzJR15zhs_s9UxalMMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/deals.vue")
  },
  {
    name: "am-login",
    path: "/am/login",
    meta: { ...(loginfoZ38QbRkupQcV6AXjs44IXhN9bzsiH5jCysBRvPiikMeta || {}), ...{"middleware":["am-login-redirect"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/login.vue")
  },
  {
    name: "b2b-team",
    path: "/b2b/team",
    meta: { ...(team_45nv8tVjsbeCCGeQCydZftD0waKjinQabGq7189W2OUcMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/b2b/team.vue")
  },
  {
    name: "p-slug___en",
    path: "/p/:slug()",
    meta: _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta || {},
    component: () => import("/usr/src/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___ar",
    path: "/ar/p/:slug()",
    meta: _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta || {},
    component: () => import("/usr/src/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___he",
    path: "/he/p/:slug()",
    meta: _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta || {},
    component: () => import("/usr/src/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___ru",
    path: "/ru/p/:slug()",
    meta: _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta || {},
    component: () => import("/usr/src/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___zh",
    path: "/zh/p/:slug()",
    meta: _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta || {},
    component: () => import("/usr/src/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___fr",
    path: "/fr/p/:slug()",
    meta: _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta || {},
    component: () => import("/usr/src/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___de",
    path: "/de/p/:slug()",
    meta: _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta || {},
    component: () => import("/usr/src/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___es",
    path: "/es/p/:slug()",
    meta: _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta || {},
    component: () => import("/usr/src/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___it",
    path: "/it/p/:slug()",
    meta: _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta || {},
    component: () => import("/usr/src/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___pt",
    path: "/pt/p/:slug()",
    meta: _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta || {},
    component: () => import("/usr/src/app/pages/p/[slug].vue")
  },
  {
    name: "p-slug___tr",
    path: "/tr/p/:slug()",
    meta: _91slug_93krPo4MZqTyMQpGOSWrlw3IGkPJW_4532vhX_452AFPOACokMeta || {},
    component: () => import("/usr/src/app/pages/p/[slug].vue")
  },
  {
    name: "rankings",
    path: "/rankings",
    meta: { ...(rankingsUEPoehRASzZ9fqkZ_kEjwjKHQJT1_GADQztSEOM4DVgMeta || {}), ...{"middleware":["is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/rankings.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: {"middleware":["is-auth-route"],"i18n":false},
    component: () => import("/usr/src/app/pages/register.vue")
  },
  {
    name: "b2b",
    path: "/b2b",
    meta: { ...(indexkn8UdRuwcD1OxlXAvpdDEZZqvxRJc13PgIBC98MH97gMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/b2b/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardUiWW5Rllx_45TsV7mUA4ADpq_45XIaBErJurYnh1mwOoY9YMeta || {}), ...{"middleware":["is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/dashboard.vue")
  },
  {
    name: "referrals",
    path: "/referrals",
    meta: { ...(referralsi7cJDsYwC8f0m_aSAPHNydI8dX8bHG68ASfZiXxSCIMMeta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/referrals.vue")
  },
  {
    name: "verify-id",
    path: "/verify-id",
    meta: { ...(verify_45idr9mq1J3JynoJh23kqgXt4dlUep9X6yhOWcorKgAvj8kMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/verify-id.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: { ...(loginbhfnU9x7MR7m12v0KzbzVvYjJ3pYqfBgGLOrjb6fFm8Meta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/auth/login.vue")
  },
  {
    name: "eval",
    path: "/eval",
    meta: { ...(indexM4aIjZXYnOMn7_pUWXKGNemIwrEbJS8fX4hIac5kgFYMeta || {}), ...{"middleware":["is-eval-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/eval/index.vue")
  },
  {
    name: "eval-login",
    path: "/eval/login",
    meta: { ...(loginMgzjaGgnC9GoieD0ZJnJGPHkrvey7DkfFj8wnY_45EtL0Meta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/eval/login.vue")
  },
  {
    name: "login-auto",
    path: "/login/auto",
    meta: { ...(auto5d8ZbmukqbIHz47QrUXybygU_4583m0xB9KxYJijK5adEMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/login/auto.vue")
  },
  {
    name: "pre-launch",
    path: "/pre-launch",
    meta: { ...(pre_45launchKf647MfxP1FD46lOwU32HOb_45ztOl7JKs7fJ5EQZuRn4Meta || {}), ...{"middleware":["is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/pre-launch.vue")
  },
  {
    name: "reset-sent",
    path: "/reset/sent",
    meta: { ...(sent98FS9DHgwHjyrdw17oOYeldfzOCOmRAP2p67Niq0fMUMeta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/reset/sent.vue")
  },
  {
    name: "saas",
    path: "/saas",
    meta: { ...(indexxAj_S_aU2eajuruoV_IIBtciDayaqwXb64PvFxNUxSYMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/saas/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexheIeQbzM9wLVSuMwWpaQiLiL4W4bdha841uk8k5lUScMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    meta: { ...(loginugK_45_45xIUOdULpo6UpztH9kvQegixIZjqKlgmmQAwKZ4Meta || {}), ...{"middleware":["admin-login-redirect"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/login.vue")
  },
  {
    name: "b2b-billing",
    path: "/b2b/billing",
    meta: { ...(billingfY_45SD05NpPjnx_45xnzZOjqChd5pW8X_Kl8NiepAHVWVYMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/b2b/billing.vue")
  },
  {
    name: "leaderboard",
    path: "/leaderboard",
    meta: { ...(leaderboarddc0O2ZdE8cToW6HWW7xn_c0McP8LQ8DwBm8YRX1iRgEMeta || {}), ...{"middleware":["is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/leaderboard.vue")
  },
  {
    name: "login-check",
    path: "/login/check",
    meta: { ...(check1Xy4ccf0hYXa8Ezrz_45uR1Rg9TN6dC_45Z3JGjTelZ0AdkMeta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/login/check.vue")
  },
  {
    name: "login-email",
    path: "/login/email",
    meta: { ...(emailVgWhkF_oGlQrCir_kVdxc0LXIudB5n_a5XRILnAaWP8Meta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/login/email.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(indexDKVd05MLJnFC29f0eB5ZuesuyGzzyi_7ngIkziaq_H8Meta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/login/index.vue")
  },
  {
    name: "lp-telegram___en",
    path: "/lp/telegram",
    meta: telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta || {},
    component: () => import("/usr/src/app/pages/lp/telegram.vue")
  },
  {
    name: "lp-telegram___ar",
    path: "/ar/lp/telegram",
    meta: telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta || {},
    component: () => import("/usr/src/app/pages/lp/telegram.vue")
  },
  {
    name: "lp-telegram___he",
    path: "/he/lp/telegram",
    meta: telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta || {},
    component: () => import("/usr/src/app/pages/lp/telegram.vue")
  },
  {
    name: "lp-telegram___ru",
    path: "/ru/lp/telegram",
    meta: telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta || {},
    component: () => import("/usr/src/app/pages/lp/telegram.vue")
  },
  {
    name: "lp-telegram___zh",
    path: "/zh/lp/telegram",
    meta: telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta || {},
    component: () => import("/usr/src/app/pages/lp/telegram.vue")
  },
  {
    name: "lp-telegram___fr",
    path: "/fr/lp/telegram",
    meta: telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta || {},
    component: () => import("/usr/src/app/pages/lp/telegram.vue")
  },
  {
    name: "lp-telegram___de",
    path: "/de/lp/telegram",
    meta: telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta || {},
    component: () => import("/usr/src/app/pages/lp/telegram.vue")
  },
  {
    name: "lp-telegram___es",
    path: "/es/lp/telegram",
    meta: telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta || {},
    component: () => import("/usr/src/app/pages/lp/telegram.vue")
  },
  {
    name: "lp-telegram___it",
    path: "/it/lp/telegram",
    meta: telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta || {},
    component: () => import("/usr/src/app/pages/lp/telegram.vue")
  },
  {
    name: "lp-telegram___pt",
    path: "/pt/lp/telegram",
    meta: telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta || {},
    component: () => import("/usr/src/app/pages/lp/telegram.vue")
  },
  {
    name: "lp-telegram___tr",
    path: "/tr/lp/telegram",
    meta: telegramUtNj8mgbBg4Apa2JAPfKJgIrqzQo6LNYAMi9WOqvGLMMeta || {},
    component: () => import("/usr/src/app/pages/lp/telegram.vue")
  },
  {
    name: "reset",
    path: "/reset",
    meta: { ...(indexONzPk2pV0BIwSdmomNoqz16XFtTc1USXtnXyXb6NOnYMeta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/reset/index.vue")
  },
  {
    name: "add-property",
    path: "/add-property",
    meta: {"middleware":["is-auth"],"i18n":false},
    component: () => import("/usr/src/app/pages/add-property.vue")
  },
  {
    name: "admin-funnel",
    path: "/admin/funnel",
    meta: { ...(funneleHgACeKKBbSzouaAXjpbgwGpHxgs3rCD4yvKdHl85EEMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/funnel.vue")
  },
  {
    name: "agency",
    path: "/agency",
    meta: { ...(indexi6ygyqnVg3LQyTtauvOef5bulAKzajDVGnfObzI2iI8Meta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/agency/index.vue")
  },
  {
    name: "agents___en",
    path: "/agents",
    meta: indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta || {},
    component: () => import("/usr/src/app/pages/agents/index.vue")
  },
  {
    name: "agents___ar",
    path: "/ar/agents",
    meta: indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta || {},
    component: () => import("/usr/src/app/pages/agents/index.vue")
  },
  {
    name: "agents___he",
    path: "/he/agents",
    meta: indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta || {},
    component: () => import("/usr/src/app/pages/agents/index.vue")
  },
  {
    name: "agents___ru",
    path: "/ru/agents",
    meta: indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta || {},
    component: () => import("/usr/src/app/pages/agents/index.vue")
  },
  {
    name: "agents___zh",
    path: "/zh/agents",
    meta: indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta || {},
    component: () => import("/usr/src/app/pages/agents/index.vue")
  },
  {
    name: "agents___fr",
    path: "/fr/agents",
    meta: indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta || {},
    component: () => import("/usr/src/app/pages/agents/index.vue")
  },
  {
    name: "agents___de",
    path: "/de/agents",
    meta: indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta || {},
    component: () => import("/usr/src/app/pages/agents/index.vue")
  },
  {
    name: "agents___es",
    path: "/es/agents",
    meta: indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta || {},
    component: () => import("/usr/src/app/pages/agents/index.vue")
  },
  {
    name: "agents___it",
    path: "/it/agents",
    meta: indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta || {},
    component: () => import("/usr/src/app/pages/agents/index.vue")
  },
  {
    name: "agents___pt",
    path: "/pt/agents",
    meta: indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta || {},
    component: () => import("/usr/src/app/pages/agents/index.vue")
  },
  {
    name: "agents___tr",
    path: "/tr/agents",
    meta: indexObRJ8RVwNvTTDIbAkhtjLnGoH4AaljkHVh8TNHp8qUEMeta || {},
    component: () => import("/usr/src/app/pages/agents/index.vue")
  },
  {
    name: "am-dashboard",
    path: "/am/dashboard",
    meta: { ...(dashboardJfzSl4jRcPqLPbH5r5_45MPqx93j5lbysEwSnWEi0dtWEMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/dashboard.vue")
  },
  {
    name: "am-uae",
    path: "/am/uae",
    meta: { ...(indexaVFxYvJu8ymaQjV0tUcccM95djaR9fqpSKr1qMIUfXIMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/uae/index.vue")
  },
  {
    name: "appointments",
    path: "/appointments",
    meta: {"middleware":["is-auth"],"i18n":false},
    component: () => import("/usr/src/app/pages/appointments.vue")
  },
  {
    name: "go-user-id",
    path: "/go/user/:id()",
    meta: { ...(_91id_93ikHy5H2Rt0goctTYL3b0IRUxjYcM2wCOQGc095ZPdX0Meta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/go/user/[id].vue")
  },
  {
    name: "login-verify",
    path: "/login/verify",
    meta: { ...(verifybRvHgKfRMtSLeRuk69LDxDG6dg8YM0qjqZzDqCixH3UMeta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/login/verify.vue")
  },
  {
    name: "profile-team",
    path: "/profile/team",
    meta: { ...(teamF4NRK08l4bcvHaPB4ooEONThDJSncKt9yvvrJ5IHSTQMeta || {}), ...{"middleware":["is-auth","is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/profile/team.vue")
  },
  {
    name: "sign-token",
    path: "/sign/:token()",
    meta: { ...(_91token_93VuWnz5FmtSh6HqWOI9FGzm9HNi5rjhXQXXuOLv2eP14Meta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/sign/[token].vue")
  },
  {
    name: "signup-email",
    path: "/signup/email",
    meta: { ...(emailLUiM_R7KsS3p3YIFMuQ4l7TSkUbDcVSbUk_jj07lQYMMeta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/signup/email.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: { ...(indexiYfC9AJ3VhIIva16wasaFSQz5iNu1lgdA4IllRk6WaQMeta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/signup/index.vue")
  },
  {
    name: "vault-slug",
    path: "/vault/:slug()",
    meta: { ...(_91slug_93pMiqqKcVyTAEDnDGsBLcRjMOEPMNc9ZklyC8moS17agMeta || {}), ...{"middleware":["unauth-vault-prompt"],"i18n":false} },
    component: () => import("/usr/src/app/pages/vault/[slug].vue")
  },
  {
    name: "admin-billing",
    path: "/admin/billing",
    meta: { ...(billingxh1qw_PzYXlluXyR_p4vx7zAKk9by0bM68SX4U1yey4Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/billing.vue")
  },
  {
    name: "am-id-reviews",
    path: "/am/id-reviews",
    meta: { ...(id_45reviewsIfHI__45dB_45nKhJYYAItlwPk4L3Bgftz5Bt9jaVsxLgwsMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/id-reviews.vue")
  },
  {
    name: "am-team",
    path: "/am/team",
    meta: { ...(indexsx8ywn4Np9Denn1myGRxTuqWw92Onj72SpvD1iYzpOIMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/team/index.vue")
  },
  {
    name: "auth-continue",
    path: "/auth/continue",
    meta: { ...(continueFR2yhS_45hYuL2aP3Y6B_p9GAkaEhqdu90Q0UjCLhfh28Meta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/auth/continue.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: { ...(registernPN_456HnqgsYNI4BuSoA30RxyPX_45hSTUN0NlsGUhK0JIMeta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/auth/register.vue")
  },
  {
    name: "b2b-deals-new",
    path: "/b2b/deals/new",
    meta: { ...(newzK9hjcMxxLl6T25BptEwcbMolDHHI_45SGQdRKhl0_45E6gMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/b2b/deals/new.vue")
  },
  {
    name: "deals-aa-form",
    path: "/deals/aa-forms/:id",
    meta: { ...(deals_45aa_45formRSHgorqfE7gi_MOx29Tb_45oL9__45_45Or4_Ep1M8CCae1N8Meta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-aa-form.vue")
  },
  {
    name: "international___en",
    path: "/international",
    meta: international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta || {},
    component: () => import("/usr/src/app/pages/international.vue")
  },
  {
    name: "international___ar",
    path: "/ar/international",
    meta: international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta || {},
    component: () => import("/usr/src/app/pages/international.vue")
  },
  {
    name: "international___he",
    path: "/he/international",
    meta: international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta || {},
    component: () => import("/usr/src/app/pages/international.vue")
  },
  {
    name: "international___ru",
    path: "/ru/international",
    meta: international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta || {},
    component: () => import("/usr/src/app/pages/international.vue")
  },
  {
    name: "international___zh",
    path: "/zh/international",
    meta: international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta || {},
    component: () => import("/usr/src/app/pages/international.vue")
  },
  {
    name: "international___fr",
    path: "/fr/international",
    meta: international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta || {},
    component: () => import("/usr/src/app/pages/international.vue")
  },
  {
    name: "international___de",
    path: "/de/international",
    meta: international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta || {},
    component: () => import("/usr/src/app/pages/international.vue")
  },
  {
    name: "international___es",
    path: "/es/international",
    meta: international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta || {},
    component: () => import("/usr/src/app/pages/international.vue")
  },
  {
    name: "international___it",
    path: "/it/international",
    meta: international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta || {},
    component: () => import("/usr/src/app/pages/international.vue")
  },
  {
    name: "international___pt",
    path: "/pt/international",
    meta: international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta || {},
    component: () => import("/usr/src/app/pages/international.vue")
  },
  {
    name: "international___tr",
    path: "/tr/international",
    meta: international2r9P7mRv3VdtAfi6nZpYnLHtCywIbhgyxKeXa0q3U2gMeta || {},
    component: () => import("/usr/src/app/pages/international.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: { ...(indexbYjd0RM4EZ1JzoPM3R_45wkMbw25gILbSV5xClx0stGDYMeta || {}), ...{"middleware":["is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/profile/index.vue")
  },
  {
    name: "property-id",
    path: "/property/:id()",
    meta: {"middleware":["is-auth"],"i18n":false},
    component: () => import("/usr/src/app/pages/property/[id].vue")
  },
  {
    name: "reset-success",
    path: "/reset/success",
    meta: { ...(successS_DSly0hbmce4Nri2uByZmbbzgg1bz8Wm8sFLvr83fcMeta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/reset/success.vue")
  },
  {
    name: "share-token",
    path: "/share/:token()",
    meta: { ...(_91token_93XA13fZZUQSMTxgn9af4u0AmavhPfBWdJqWnUBTLySkIMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/share/[token].vue")
  },
  {
    name: "b2b-deals-id",
    path: "/b2b/deals/:id()",
    meta: { ...(_91id_93jpiq0evCwhC51WspIbGjGfgBeCmEtBLRo8DRDz6Pw04Meta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/b2b/deals/[id].vue")
  },
  {
    name: "deals-aa-forms",
    path: "/deals/aa-forms",
    meta: { ...(deals_45aa_45forms_cpcySQDno26zM4DJlAUONeFShqY3HFKADVCCF8jaSUMeta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-aa-forms.vue")
  },
  {
    name: "deals-register",
    path: "/deals/register",
    meta: { ...(deals_45registerH6xoOccVVn__h_458SUgVh3ZyNwb3OaFqFvb_45sB8M5uHgMeta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register.vue")
  },
  {
    name: "delete-account",
    path: "/delete-account",
    meta: { ...(delete_45accountqfxtzETedZ1XcuyM7kCf5Db1Ck4mbOouYs4Znq21ejkMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/delete-account.vue")
  },
  {
    name: "payment-failed",
    path: "/payment/failed",
    meta: {"i18n":false},
    component: () => import("/usr/src/app/pages/payment/failed.vue")
  },
  {
    name: "reset-password",
    path: "/reset/password",
    meta: { ...(passwordyZzfleCrhsGzlYQoMRwVUhstiasyDvmo1Ak2kL9FgjoMeta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/reset/password.vue")
  },
  {
    name: "services___en",
    path: "/services",
    meta: indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {},
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "services___ar",
    path: "/ar/services",
    meta: indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {},
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "services___he",
    path: "/he/services",
    meta: indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {},
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "services___ru",
    path: "/ru/services",
    meta: indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {},
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "services___zh",
    path: "/zh/services",
    meta: indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {},
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "services___fr",
    path: "/fr/services",
    meta: indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {},
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "services___de",
    path: "/de/services",
    meta: indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {},
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "services___es",
    path: "/es/services",
    meta: indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {},
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "services___it",
    path: "/it/services",
    meta: indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {},
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "services___pt",
    path: "/pt/services",
    meta: indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {},
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "services___tr",
    path: "/tr/services",
    meta: indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {},
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "shared-answers",
    path: "/shared-answers",
    meta: { ...(shared_45answerss30PNq1376MP0PO8QQIGDq4h4Ex7Z_454_45bqJa4GLsVjkMeta || {}), ...{"middleware":["is-auth","is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/shared-answers.vue")
  },
  {
    name: "signup-contact",
    path: "/signup/contact",
    meta: { ...(contactiE3rLZl094u_JJl_6nbWUL0HFPdKn_jKxBtUnkjtDNAMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/signup/contact.vue")
  },
  {
    name: "signup-welcome",
    path: "/signup/welcome",
    meta: { ...(welcomejrpQs9yHWWP32lct_45KdlrhWb4BzrnSbWUWwsNfadyj8Meta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/signup/welcome.vue")
  },
  {
    name: "training",
    path: "/training",
    meta: {"i18n":false},
    component: () => import("/usr/src/app/pages/training/index.vue")
  },
  {
    name: "aa-sign-token",
    path: "/aa-sign/:token()",
    meta: { ...(_91token_93ydpfSGSQAuHqp6VSz088oIxs03Xk6l7sWMhnluvw0YoMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/aa-sign/[token].vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    meta: { ...(dashboardtx6deMYfoKD7h5QYabhFN0OMrIRPz18n3x86zBDRTDEMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/dashboard.vue")
  },
  {
    name: "admin-uae",
    path: "/admin/uae",
    meta: { ...(indexOpvahcvGVxQTSBIG_45b6GNnHBfZbhSilv_45ffz0FUG8wsMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/uae/index.vue")
  },
  {
    name: "admin-uae-joins",
    path: "/admin/uae/joins",
    meta: { ...(joinsqYTfJcD9CLu7knvZ3Kn78TYOlAq3tD_GwSEiZkRZgQYMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/uae/joins.vue")
  },
  {
    name: "am-agents",
    path: "/am/agents",
    meta: { ...(indexcKQzYZF6GtgcSum3n_45CJ6C_4Z0i7DS7MY8Zcx_451utUsMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/agents/index.vue")
  },
  {
    name: "b2b-clients-new",
    path: "/b2b/clients/new",
    meta: { ...(newSKRHMfIP4POr2VLFBqwlthTTx7Pe1Z9qvoGNwrwz1vgMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/b2b/clients/new.vue")
  },
  {
    name: "b2b-deals",
    path: "/b2b/deals",
    meta: { ...(indexdmqlBNPmzWa0nNZS89yTrMgrvn3R729wBjTUHLnXFegMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/b2b/deals/index.vue")
  },
  {
    name: "developer-vault",
    path: "/developer-vault",
    meta: { ...(developer_45vaultwbHseQPF6YsXnS5DlKtd10_45m9UgH5PrRurBWywFB6wkMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/developer-vault.vue")
  },
  {
    name: "developer-apply",
    path: "/developer/apply",
    meta: { ...(applyW2fGsKaXzkWi4fWfgcpy1aFfx3KWd0DnnhgFSKTYH8EMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/apply.vue")
  },
  {
    name: "developer",
    path: "/developer",
    meta: { ...(indexdjxqytI7DhHB_45qQPIkPTsmeJ1nOvvNZr_45BsfjUm7rNsMeta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/index.vue")
  },
  {
    name: "marketing",
    path: "/marketing",
    meta: { ...(index44O1Uc8f_Kb3FgY1AYSdzT2v_45DJT5ZAToSbh0kPp96wMeta || {}), ...{"middleware":["is-auth","is-agent","is-verified"],"i18n":false} },
    component: () => import("/usr/src/app/pages/marketing/index.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    meta: {"i18n":false},
    component: () => import("/usr/src/app/pages/payment/success.vue")
  },
  {
    name: "properties-id___en",
    path: "/properties/:id()",
    meta: _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta || {},
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "properties-id___ar",
    path: "/ar/properties/:id()",
    meta: _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta || {},
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "properties-id___he",
    path: "/he/properties/:id()",
    meta: _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta || {},
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "properties-id___ru",
    path: "/ru/properties/:id()",
    meta: _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta || {},
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "properties-id___zh",
    path: "/zh/properties/:id()",
    meta: _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta || {},
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "properties-id___fr",
    path: "/fr/properties/:id()",
    meta: _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta || {},
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "properties-id___de",
    path: "/de/properties/:id()",
    meta: _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta || {},
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "properties-id___es",
    path: "/es/properties/:id()",
    meta: _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta || {},
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "properties-id___it",
    path: "/it/properties/:id()",
    meta: _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta || {},
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "properties-id___pt",
    path: "/pt/properties/:id()",
    meta: _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta || {},
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "properties-id___tr",
    path: "/tr/properties/:id()",
    meta: _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta || {},
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "signup-password",
    path: "/signup/password",
    meta: { ...(password76ZjmO5rQF8sYiBrWAzMljIFEjSgdamwkO8csEnrNpcMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/signup/password.vue")
  },
  {
    name: "training-slug",
    path: "/training/:slug()",
    meta: { ...(_91slug_93eh87CLWxF9zmzSb_45dC8z_45m70mhzBRBHZMggVyLas0nQMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/training/[slug].vue")
  },
  {
    name: "a-handle",
    path: "/a/:handle()",
    meta: { ...(indexBlnI5xY7gFHjJu8LGsrPxWP_45jRjpQb8TkkvpjIiJS1sMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/a/[handle]/index.vue")
  },
  {
    name: "admin-uae-agents",
    path: "/admin/uae/agents",
    meta: { ...(agentsML2hu0Qrv5YSR2TFu_j0Vq7vURP6YAbkcmnDS3uo8x4Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/uae/agents.vue")
  },
  {
    name: "am-team-managers",
    path: "/am/team/managers",
    meta: { ...(managersC2nxVdLyf5fl3ZSNuXtuQDnuLzHlFVsDr3RSTDnG4SQMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/team/managers.vue")
  },
  {
    name: "auth-reset",
    path: "/auth/reset",
    meta: { ...(indexpZL9jQqY5UdFGmgJFVy4Hb7ebJz91COEQ82DNQQ_45534Meta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/auth/reset/index.vue")
  },
  {
    name: "b2b-clients-id",
    path: "/b2b/clients/:id()",
    meta: { ...(_91id_93vLdDZcWrKHPgc9X5M92yESLpKM60fgUcwOCSZzk7di4Meta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/b2b/clients/[id].vue")
  },
  {
    name: "b2b-join-token",
    path: "/b2b/join/:token()",
    meta: { ...(_91token_93FaJ8IQk4YudgnrsSeYsSGIVd71nyK9fgFoXFNf3fFnAMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/b2b/join/[token].vue")
  },
  {
    name: "billing-uae-team",
    path: "/billing/uae-team",
    meta: { ...(uae_45teamwRG0JW_45i9TPBgxWqvEhUHSZ1CWVjmWRKEDLf_pxMqHUMeta || {}), ...{"middleware":["is-auth","is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/billing/uae-team.vue")
  },
  {
    name: "developers___en",
    path: "/developers",
    meta: indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta || {},
    component: () => import("/usr/src/app/pages/developers/index.vue")
  },
  {
    name: "developers___ar",
    path: "/ar/developers",
    meta: indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta || {},
    component: () => import("/usr/src/app/pages/developers/index.vue")
  },
  {
    name: "developers___he",
    path: "/he/developers",
    meta: indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta || {},
    component: () => import("/usr/src/app/pages/developers/index.vue")
  },
  {
    name: "developers___ru",
    path: "/ru/developers",
    meta: indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta || {},
    component: () => import("/usr/src/app/pages/developers/index.vue")
  },
  {
    name: "developers___zh",
    path: "/zh/developers",
    meta: indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta || {},
    component: () => import("/usr/src/app/pages/developers/index.vue")
  },
  {
    name: "developers___fr",
    path: "/fr/developers",
    meta: indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta || {},
    component: () => import("/usr/src/app/pages/developers/index.vue")
  },
  {
    name: "developers___de",
    path: "/de/developers",
    meta: indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta || {},
    component: () => import("/usr/src/app/pages/developers/index.vue")
  },
  {
    name: "developers___es",
    path: "/es/developers",
    meta: indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta || {},
    component: () => import("/usr/src/app/pages/developers/index.vue")
  },
  {
    name: "developers___it",
    path: "/it/developers",
    meta: indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta || {},
    component: () => import("/usr/src/app/pages/developers/index.vue")
  },
  {
    name: "developers___pt",
    path: "/pt/developers",
    meta: indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta || {},
    component: () => import("/usr/src/app/pages/developers/index.vue")
  },
  {
    name: "developers___tr",
    path: "/tr/developers",
    meta: indexxHxc_450vl8JyLEOX2vz03OGuMJXyyS6ZRzEbDTSDkqqcMeta || {},
    component: () => import("/usr/src/app/pages/developers/index.vue")
  },
  {
    name: "payments-history",
    path: "/payments-history",
    meta: { ...(payments_45historyQJi8UKBejqiINvOKcUKQgaKLCPj3gCLtlZF95qdm4kMMeta || {}), ...{"middleware":["is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/payments-history.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(indexZLYQ8fDwPFkWNtKloeYk5uEnQbR3BebLOi0lL_hIQEAMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/users/index.vue")
  },
  {
    name: "am-campaigns-id",
    path: "/am/campaigns/:id()",
    meta: { ...(_91id_93K75xXEqre98HlN_G3Pk5AzRgV1g9Y0k3Saa11XGOhrAMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/campaigns/[id].vue")
  },
  {
    name: "b2b-clients",
    path: "/b2b/clients",
    meta: { ...(indexHOLpEhYvGHxTHWio9si_45VD3rdVZG6o057G1LbRS2aDgMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/b2b/clients/index.vue")
  },
  {
    name: "b2b-setup-token",
    path: "/b2b/setup/:token()",
    meta: { ...(_91token_93gJ_45bhVeiYzv2mfBp14NdSWs1sRmGqZLpOjt8m5eO4T0Meta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/b2b/setup/[token].vue")
  },
  {
    name: "deals-aa-form-new",
    path: "/deals/aa-forms/new",
    meta: { ...(deals_45aa_45form_45newgLFKNDdmsXXUtXi1_45IDBELewvGIK9N_45Rf2NwvWbm05kMeta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-aa-form-new.vue")
  },
  {
    name: "developers-slug___en",
    path: "/developers/:slug()",
    meta: _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta || {},
    component: () => import("/usr/src/app/pages/developers/[slug].vue")
  },
  {
    name: "developers-slug___ar",
    path: "/ar/developers/:slug()",
    meta: _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta || {},
    component: () => import("/usr/src/app/pages/developers/[slug].vue")
  },
  {
    name: "developers-slug___he",
    path: "/he/developers/:slug()",
    meta: _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta || {},
    component: () => import("/usr/src/app/pages/developers/[slug].vue")
  },
  {
    name: "developers-slug___ru",
    path: "/ru/developers/:slug()",
    meta: _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta || {},
    component: () => import("/usr/src/app/pages/developers/[slug].vue")
  },
  {
    name: "developers-slug___zh",
    path: "/zh/developers/:slug()",
    meta: _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta || {},
    component: () => import("/usr/src/app/pages/developers/[slug].vue")
  },
  {
    name: "developers-slug___fr",
    path: "/fr/developers/:slug()",
    meta: _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta || {},
    component: () => import("/usr/src/app/pages/developers/[slug].vue")
  },
  {
    name: "developers-slug___de",
    path: "/de/developers/:slug()",
    meta: _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta || {},
    component: () => import("/usr/src/app/pages/developers/[slug].vue")
  },
  {
    name: "developers-slug___es",
    path: "/es/developers/:slug()",
    meta: _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta || {},
    component: () => import("/usr/src/app/pages/developers/[slug].vue")
  },
  {
    name: "developers-slug___it",
    path: "/it/developers/:slug()",
    meta: _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta || {},
    component: () => import("/usr/src/app/pages/developers/[slug].vue")
  },
  {
    name: "developers-slug___pt",
    path: "/pt/developers/:slug()",
    meta: _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta || {},
    component: () => import("/usr/src/app/pages/developers/[slug].vue")
  },
  {
    name: "developers-slug___tr",
    path: "/tr/developers/:slug()",
    meta: _91slug_93Z9IktGpxszk_458BZ9UROYYbfL0egsIdlqVkB929dP8KEMeta || {},
    component: () => import("/usr/src/app/pages/developers/[slug].vue")
  },
  {
    name: "email-unsubscribe",
    path: "/email/unsubscribe",
    meta: { ...(unsubscribeuDlsUZYufuoLuS3oJcnnsLtTJkKBCSqMrRnf2lHBgGsMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/email/unsubscribe.vue")
  },
  {
    name: "masterclass___en",
    path: "/masterclass",
    meta: indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/index.vue")
  },
  {
    name: "masterclass___ar",
    path: "/ar/masterclass",
    meta: indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/index.vue")
  },
  {
    name: "masterclass___he",
    path: "/he/masterclass",
    meta: indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/index.vue")
  },
  {
    name: "masterclass___ru",
    path: "/ru/masterclass",
    meta: indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/index.vue")
  },
  {
    name: "masterclass___zh",
    path: "/zh/masterclass",
    meta: indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/index.vue")
  },
  {
    name: "masterclass___fr",
    path: "/fr/masterclass",
    meta: indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/index.vue")
  },
  {
    name: "masterclass___de",
    path: "/de/masterclass",
    meta: indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/index.vue")
  },
  {
    name: "masterclass___es",
    path: "/es/masterclass",
    meta: indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/index.vue")
  },
  {
    name: "masterclass___it",
    path: "/it/masterclass",
    meta: indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/index.vue")
  },
  {
    name: "masterclass___pt",
    path: "/pt/masterclass",
    meta: indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/index.vue")
  },
  {
    name: "masterclass___tr",
    path: "/tr/masterclass",
    meta: indexg9YiQzMuyez_SvXWrnGP1Bc3M9TwxylmG2vAlgSS2ZEMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/index.vue")
  },
  {
    name: "masterclass-learn",
    path: "/masterclass/learn",
    meta: { ...(learnnzeA_ywHGo_45w_znTVN_oRTB0LTAm8YXbcLx5qdb7_FIMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/masterclass/learn.vue")
  },
  {
    name: "masterclass-login",
    path: "/masterclass/login",
    meta: { ...(loginh4MSQqIHg5xN7lwSHC0tvdh6qHA30ZKZCxcEqKajXYMMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/masterclass/login.vue")
  },
  {
    name: "masterclass-start___en",
    path: "/masterclass/start",
    meta: startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta || {},
    component: () => import("/usr/src/app/pages/masterclass/start.vue")
  },
  {
    name: "masterclass-start___ar",
    path: "/ar/masterclass/start",
    meta: startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta || {},
    component: () => import("/usr/src/app/pages/masterclass/start.vue")
  },
  {
    name: "masterclass-start___he",
    path: "/he/masterclass/start",
    meta: startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta || {},
    component: () => import("/usr/src/app/pages/masterclass/start.vue")
  },
  {
    name: "masterclass-start___ru",
    path: "/ru/masterclass/start",
    meta: startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta || {},
    component: () => import("/usr/src/app/pages/masterclass/start.vue")
  },
  {
    name: "masterclass-start___zh",
    path: "/zh/masterclass/start",
    meta: startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta || {},
    component: () => import("/usr/src/app/pages/masterclass/start.vue")
  },
  {
    name: "masterclass-start___fr",
    path: "/fr/masterclass/start",
    meta: startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta || {},
    component: () => import("/usr/src/app/pages/masterclass/start.vue")
  },
  {
    name: "masterclass-start___de",
    path: "/de/masterclass/start",
    meta: startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta || {},
    component: () => import("/usr/src/app/pages/masterclass/start.vue")
  },
  {
    name: "masterclass-start___es",
    path: "/es/masterclass/start",
    meta: startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta || {},
    component: () => import("/usr/src/app/pages/masterclass/start.vue")
  },
  {
    name: "masterclass-start___it",
    path: "/it/masterclass/start",
    meta: startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta || {},
    component: () => import("/usr/src/app/pages/masterclass/start.vue")
  },
  {
    name: "masterclass-start___pt",
    path: "/pt/masterclass/start",
    meta: startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta || {},
    component: () => import("/usr/src/app/pages/masterclass/start.vue")
  },
  {
    name: "masterclass-start___tr",
    path: "/tr/masterclass/start",
    meta: startks5C7SGMh_Q93NyBNTG4G87wrG9hvCOuCl4WToPv1y8Meta || {},
    component: () => import("/usr/src/app/pages/masterclass/start.vue")
  },
  {
    name: "my-services",
    path: "/my-services",
    meta: { ...(indexuogMiTNn_DqazL6bsM90b3I3F9EKWcAsHCvo_45rYZs6oMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/my-services/index.vue")
  },
  {
    name: "payment-abandoned",
    path: "/payment/abandoned",
    meta: {"i18n":false},
    component: () => import("/usr/src/app/pages/payment/abandoned.vue")
  },
  {
    name: "admin-agents",
    path: "/admin/agents",
    meta: { ...(indexokcMVH0CKxtcvLltk0HIDp3_5olfCVZZHAMLUigibLEMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/agents/index.vue")
  },
  {
    name: "admin-integrations",
    path: "/admin/integrations",
    meta: { ...(integrationsSK37QOQinI7MGlQZ0XvXxL9iTa0j3CS6DAlvNP9hoHMMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/integrations.vue")
  },
  {
    name: "admin-uae-settings",
    path: "/admin/uae/settings",
    meta: { ...(settingsw87RHY_uD67S12o7MTz9U65_45tsGBGi4opLqFdSoLamYMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/uae/settings.vue")
  },
  {
    name: "am-agents-register",
    path: "/am/agents/register",
    meta: { ...(registerZQrEBv1YgF1bYQMPnyH96SjHJltb_tgoDP2ofarMMlUMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/agents/register.vue")
  },
  {
    name: "am-campaigns",
    path: "/am/campaigns",
    meta: { ...(indexuSVT_45C4CUFOyy8ou4ptP1QmMBiLVUszoV4EsYg4THFsMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/campaigns/index.vue")
  },
  {
    name: "developer-news-new",
    path: "/developer/news/new",
    meta: { ...(newiJOVjeoSscWLHQeRrb5bvnVqF9LKill5p5d7UgFuUvcMeta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/news/new.vue")
  },
  {
    name: "developer-overview",
    path: "/developer/overview",
    meta: { ...(overviewe8CnlrT0djJSfL4kH3FWOc7c8gOmB0c_uR4w5pXHf64Meta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/overview.vue")
  },
  {
    name: "developer-settings",
    path: "/developer/settings",
    meta: { ...(settingsAKToVo_2jXhlytOaQwoRPQ3BkkVC_45fUp3StaB0Il_V0Meta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/settings.vue")
  },
  {
    name: "my-services-slug",
    path: "/my-services/:slug()",
    meta: { ...(_91slug_93y1Y1KV11DNSF8Nb_45tmou590GQZvxNDSPbc_45hINX2NOMMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/my-services/[slug].vue")
  },
  {
    name: "services-thank-you___en",
    path: "/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "services-thank-you___ar",
    path: "/ar/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "services-thank-you___he",
    path: "/he/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "services-thank-you___ru",
    path: "/ru/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "services-thank-you___zh",
    path: "/zh/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "services-thank-you___fr",
    path: "/fr/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "services-thank-you___de",
    path: "/de/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "services-thank-you___es",
    path: "/es/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "services-thank-you___it",
    path: "/it/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "services-thank-you___pt",
    path: "/pt/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "services-thank-you___tr",
    path: "/tr/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "admin-agencies-id",
    path: "/admin/agencies/:id()",
    meta: { ...(_91id_93nWqri_45r9Pb_45B5jpVmzBjISXY7hlJKZCml6NPLCZWDQ8Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/agencies/[id].vue")
  },
  {
    name: "admin-packages-id",
    path: "/admin/packages/:id()",
    meta: { ...(_91id_93unlNT8JnDVHxXuwudC5utfpOyEX_45R1lThhDnrmuGGb4Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/packages/[id].vue")
  },
  {
    name: "admin-payouts",
    path: "/admin/payouts",
    meta: { ...(index_45TDrQ7tdxssho3ssGYo5bJGg8SNxv5PICsq77Miq0YEMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/payouts/index.vue")
  },
  {
    name: "admin-services-id",
    path: "/admin/services/:id()",
    meta: { ...(_91id_9324RLyENccp0kuLN3IsquBdrfh3TbdaowW1W76zs8eisMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/services/[id].vue")
  },
  {
    name: "admin-training-id",
    path: "/admin/training/:id()",
    meta: { ...(_91id_937GLCTrFVlNhLfBDVPtfcS6QLIBaclb5_M77lUu3naNAMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/training/[id].vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset/password",
    meta: { ...(passwordFgz6F8_jyP38Q1ArYRR6C9wfvnJyxCsUwYNpT626Iz8Meta || {}), ...{"middleware":["is-auth-route"],"i18n":false} },
    component: () => import("/usr/src/app/pages/auth/reset/password.vue")
  },
  {
    name: "certificates-code",
    path: "/certificates/:code()",
    meta: { ...(_91code_9364moMHt7OhnoBqLOkPF48ceyTxU70h1ZN0B_45jVX_VRQMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/certificates/[code].vue")
  },
  {
    name: "deals-register-path",
    path: "/deals/register/path",
    meta: { ...(deals_45register_45pathUXZ4rOkHxlmcYkTTq5gNa77FYxMTTlicEDcGVTZtrK0Meta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register-path.vue")
  },
  {
    name: "developer-news-id",
    path: "/developer/news/:id()",
    meta: { ...(_91id_930IwbIebnPmm58Filbe3C5mFFi5LDyb9JWlbY8b9U6iwMeta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/news/[id].vue")
  },
  {
    name: "admin-agencies",
    path: "/admin/agencies",
    meta: { ...(indexIWKRTXVS4i8_S5d1f_45xiFGJrFVshtGRfrNUFP4IAPMkMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/agencies/index.vue")
  },
  {
    name: "admin-b2b-deals-id",
    path: "/admin/b2b-deals/:id()",
    meta: { ...(_91id_93FhUxFNaKDcQXyTzTjKv323g61TGkjqsx2tB7CcedTbUMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/b2b-deals/[id].vue")
  },
  {
    name: "admin-campaigns-id",
    path: "/admin/campaigns/:id()",
    meta: { ...(_91id_93PoYyhtTmRW3misi38kR8F_454y3iGvGTH_Y6pgS0YgO0IMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/campaigns/[id].vue")
  },
  {
    name: "admin-packages",
    path: "/admin/packages",
    meta: { ...(indexp9M2HIAmvBUyWLQ6eYEWlTX8Dl_Dfxryg6YmqVk3a9kMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/packages/index.vue")
  },
  {
    name: "admin-projects",
    path: "/admin/projects",
    meta: { ...(indexubsmO1lDtgO_45SdOx3iA_OcqEzDcRuUV8w2yqrcu_457fgMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/projects/index.vue")
  },
  {
    name: "admin-services",
    path: "/admin/services",
    meta: { ...(indexEBWTFfEKoZAv1rhzjWBzKro4uWRUW8qhOTag4xPj1cMMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/services/index.vue")
  },
  {
    name: "admin-training",
    path: "/admin/training",
    meta: { ...(indexNx5rXMS8CTJa5FmWIUSLZiCQwkDtBOh2k9rlwzY9KPUMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/training/index.vue")
  },
  {
    name: "admin-uae-id-reviews",
    path: "/admin/uae/id-reviews",
    meta: { ...(id_45reviewsOrNyB0uC_182OG4hhi9Ce2COh8MzpYivJckCykyB5o0Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/uae/id-reviews.vue")
  },
  {
    name: "am-service-referrals",
    path: "/am/service-referrals",
    meta: { ...(service_45referralsQ9qnuDTzPmTWNu16tn9QTgwBZZTY604wfYgH2sIhOygMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/service-referrals.vue")
  },
  {
    name: "developer-news",
    path: "/developer/news",
    meta: { ...(indexq46dzVm36_4JpueEJ1VvBTo43u5S_45THoSEn6XNoRMxIMeta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/news/index.vue")
  },
  {
    name: "my-services-checkout",
    path: "/my-services/checkout",
    meta: { ...(checkout9EoD5npkEPKvvVBZ4MiC8RVFnaGfMQ55MF_CXG9iVEEMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/my-services/checkout.vue")
  },
  {
    name: "admin-b2b-deals",
    path: "/admin/b2b-deals",
    meta: { ...(indexm2w_ZtvYNf49Bl0VqUdBW4n1kvZyWAhhw7SmufLlP4MMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/b2b-deals/index.vue")
  },
  {
    name: "admin-campaigns",
    path: "/admin/campaigns",
    meta: { ...(indexObqkzPaje4QZCScH1tbXDvwYpHVHxbeEHwV6cLEevKYMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/campaigns/index.vue")
  },
  {
    name: "admin-hidden-projects",
    path: "/admin/hidden-projects",
    meta: { ...(hidden_45projects_sPPq2rAbzSbwlIu6JOTyCNzo_45PyVnTC3tSQ_45IA8QgIMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/hidden-projects.vue")
  },
  {
    name: "admin-packages-create",
    path: "/admin/packages/create",
    meta: { ...(createKgl0UaLfqhle0SWKc0Er9_453IL6CikifD2KyJROehzigMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/packages/create.vue")
  },
  {
    name: "admin-portfolio",
    path: "/admin/portfolio",
    meta: { ...(indexWnTQoJMMuhQFDR_45UOb3MmSIDBLwK8fBU_nwbQrv9sisMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/portfolio/index.vue")
  },
  {
    name: "admin-resale-listings",
    path: "/admin/resale-listings",
    meta: { ...(resale_45listingsMXjeukkGkm16iHURHXx4q_45PhUTYHBIken7EzY8FP_45aMMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/resale-listings.vue")
  },
  {
    name: "admin-services-create",
    path: "/admin/services/create",
    meta: { ...(createJOMwe_jqlWz45vn00sdNfzVa4WWrmahGbpTlDC33_45_YMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/services/create.vue")
  },
  {
    name: "admin-training-create",
    path: "/admin/training/create",
    meta: { ...(created29qSRyZK76XezIGz8Q4OXIUdFF4L3k2eTlWd8w72GMMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/training/create.vue")
  },
  {
    name: "masterclass-variant___en",
    path: "/masterclass/:variant()",
    meta: _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/[variant].vue")
  },
  {
    name: "masterclass-variant___ar",
    path: "/ar/masterclass/:variant()",
    meta: _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/[variant].vue")
  },
  {
    name: "masterclass-variant___he",
    path: "/he/masterclass/:variant()",
    meta: _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/[variant].vue")
  },
  {
    name: "masterclass-variant___ru",
    path: "/ru/masterclass/:variant()",
    meta: _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/[variant].vue")
  },
  {
    name: "masterclass-variant___zh",
    path: "/zh/masterclass/:variant()",
    meta: _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/[variant].vue")
  },
  {
    name: "masterclass-variant___fr",
    path: "/fr/masterclass/:variant()",
    meta: _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/[variant].vue")
  },
  {
    name: "masterclass-variant___de",
    path: "/de/masterclass/:variant()",
    meta: _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/[variant].vue")
  },
  {
    name: "masterclass-variant___es",
    path: "/es/masterclass/:variant()",
    meta: _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/[variant].vue")
  },
  {
    name: "masterclass-variant___it",
    path: "/it/masterclass/:variant()",
    meta: _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/[variant].vue")
  },
  {
    name: "masterclass-variant___pt",
    path: "/pt/masterclass/:variant()",
    meta: _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/[variant].vue")
  },
  {
    name: "masterclass-variant___tr",
    path: "/tr/masterclass/:variant()",
    meta: _91variant_93KygbdNRQBSnRl9Wgvk5sDW7hV71kqQEIgauvRhiNY9EMeta || {},
    component: () => import("/usr/src/app/pages/masterclass/[variant].vue")
  },
  {
    name: "property-hash",
    path: "/property/:hash()",
    meta: {"i18n":false},
    component: () => import("/usr/src/app/pages/property/[hash]/index.vue")
  },
  {
    name: "services-slug___en",
    path: "/services/:slug()",
    meta: { ...(indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/index.vue")
  },
  {
    name: "services-slug___ar",
    path: "/ar/services/:slug()",
    meta: { ...(indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/index.vue")
  },
  {
    name: "services-slug___he",
    path: "/he/services/:slug()",
    meta: { ...(indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/index.vue")
  },
  {
    name: "services-slug___ru",
    path: "/ru/services/:slug()",
    meta: { ...(indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/index.vue")
  },
  {
    name: "services-slug___zh",
    path: "/zh/services/:slug()",
    meta: { ...(indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/index.vue")
  },
  {
    name: "services-slug___fr",
    path: "/fr/services/:slug()",
    meta: { ...(indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/index.vue")
  },
  {
    name: "services-slug___de",
    path: "/de/services/:slug()",
    meta: { ...(indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/index.vue")
  },
  {
    name: "services-slug___es",
    path: "/es/services/:slug()",
    meta: { ...(indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/index.vue")
  },
  {
    name: "services-slug___it",
    path: "/it/services/:slug()",
    meta: { ...(indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/index.vue")
  },
  {
    name: "services-slug___pt",
    path: "/pt/services/:slug()",
    meta: { ...(indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/index.vue")
  },
  {
    name: "services-slug___tr",
    path: "/tr/services/:slug()",
    meta: { ...(indexbw4QY7ZK_45nMRjSaVW6_zDvHgXwLc2jM8l_45z2u2yDXOEMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/index.vue")
  },
  {
    name: "admin-activation",
    path: "/admin/activation",
    meta: { ...(indexgjv_45jTV_455l9UqduRxt1LQCS45OaMNZl09uDS6FSYnScMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/activation/index.vue")
  },
  {
    name: "admin-agencies-payouts",
    path: "/admin/agencies/payouts",
    meta: { ...(payoutsnR2OwzvSvmMKf5amCIryqGcsbAhu0g7PojR4DUIfObQMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/agencies/payouts.vue")
  },
  {
    name: "admin-b2b-agencies-new",
    path: "/admin/b2b-agencies/new",
    meta: { ...(newHl0d8Hv_45mIX9sn2tZ47C49YtUBGQl8x7NmR4qj6lBikMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/b2b-agencies/new.vue")
  },
  {
    name: "admin-exclusives",
    path: "/admin/exclusives",
    meta: { ...(indexZq262dbaDFieJ4ZkpyVCvzLDQMQIgZP4uJkO3DuW4vYMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/exclusives/index.vue")
  },
  {
    name: "admin-resale-enquiries",
    path: "/admin/resale-enquiries",
    meta: { ...(resale_45enquiriesQRKDdH8UY1nwaJI8tjThl7H5ysUsodxhSXw6DvG8jBgMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/resale-enquiries.vue")
  },
  {
    name: "admin-service-settings",
    path: "/admin/service-settings",
    meta: { ...(service_45settingsyw9_45egotmvjR84qoK_45o9YZq_aWnwpqP0uyKleF_45ZgnoMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/service-settings.vue")
  },
  {
    name: "am-service-orders-id",
    path: "/am/service-orders/:id()",
    meta: { ...(_91id_93YEqOVviuo6hA5vT8aMZxU9JvFZYwkZhKauXGkHXLHeUMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/service-orders/[id].vue")
  },
  {
    name: "developer-distribution",
    path: "/developer/distribution",
    meta: { ...(distributionodIC7_45_45IHhx2u_9I4b6uhMWAWw5xzBw8_PbBapZIRrQMeta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/distribution.vue")
  },
  {
    name: "developer-projects-new",
    path: "/developer/projects/new",
    meta: { ...(newX_p4ngwLDpf_45HHkH1oe3DvOzHOOgV7ZvBCO7NuM6AtMMeta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/projects/new.vue")
  },
  {
    name: "masterclass-onboarding",
    path: "/masterclass/onboarding",
    meta: { ...(onboardingXOAs0Revoedgmkv2iJaRogawXXuo3rs4ne8eocxgBG4Meta || {}), ...{"middleware":["is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/masterclass/onboarding.vue")
  },
  {
    name: "onboarding-agent-phone",
    path: "/onboarding/agent-phone",
    meta: { ...(agent_45phoneODAvhN2kgU0S0hq8JUEs2rtlFyfaBifyXiyxOtZb98sMeta || {}), ...{"middleware":["is-agent"],"i18n":false} },
    component: () => import("/usr/src/app/pages/onboarding/agent-phone.vue")
  },
  {
    name: "services-slug-submit___en",
    path: "/services/:slug()/submit",
    meta: { ...(submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submit.vue")
  },
  {
    name: "services-slug-submit___ar",
    path: "/ar/services/:slug()/submit",
    meta: { ...(submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submit.vue")
  },
  {
    name: "services-slug-submit___he",
    path: "/he/services/:slug()/submit",
    meta: { ...(submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submit.vue")
  },
  {
    name: "services-slug-submit___ru",
    path: "/ru/services/:slug()/submit",
    meta: { ...(submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submit.vue")
  },
  {
    name: "services-slug-submit___zh",
    path: "/zh/services/:slug()/submit",
    meta: { ...(submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submit.vue")
  },
  {
    name: "services-slug-submit___fr",
    path: "/fr/services/:slug()/submit",
    meta: { ...(submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submit.vue")
  },
  {
    name: "services-slug-submit___de",
    path: "/de/services/:slug()/submit",
    meta: { ...(submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submit.vue")
  },
  {
    name: "services-slug-submit___es",
    path: "/es/services/:slug()/submit",
    meta: { ...(submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submit.vue")
  },
  {
    name: "services-slug-submit___it",
    path: "/it/services/:slug()/submit",
    meta: { ...(submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submit.vue")
  },
  {
    name: "services-slug-submit___pt",
    path: "/pt/services/:slug()/submit",
    meta: { ...(submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submit.vue")
  },
  {
    name: "services-slug-submit___tr",
    path: "/tr/services/:slug()/submit",
    meta: { ...(submitmCvjcbhwrmVHW7vOAGEQqLPWTFjMSLpKKTJ9iBmrYIoMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submit.vue")
  },
  {
    name: "admin-account-deletions",
    path: "/admin/account-deletions",
    meta: { ...(account_45deletionsNBo41609QFeFG0aMiiy5hT_45TUyFGD7wFaQ5Ud5zT_45VcMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/account-deletions.vue")
  },
  {
    name: "admin-agencies-settings",
    path: "/admin/agencies/settings",
    meta: { ...(settingskvUQvLCHbYRFZz36gN2ZUk6iGmyPtsRdJs5ff6p24xIMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/agencies/settings.vue")
  },
  {
    name: "admin-agent-deals",
    path: "/admin/agent-deals",
    meta: { ...(indexwA5gP9GtQ69TH0oSBKRJicG0GePJyhjEBTC5sFEFOOMMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/agent-deals/index.vue")
  },
  {
    name: "admin-b2b-agencies-id",
    path: "/admin/b2b-agencies/:id()",
    meta: { ...(_91id_932UyKTHbKeVPdP5yrhrGpsL8uE2OPX2qZkajhdTaPCW4Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/b2b-agencies/[id].vue")
  },
  {
    name: "admin-b2b-payouts",
    path: "/admin/b2b-payouts",
    meta: { ...(indexXphsBCVVCXQ_45RexibN5Dqjwtx0CLPEIbc1TeLBY0Q4oMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/b2b-payouts/index.vue")
  },
  {
    name: "admin-masterclass",
    path: "/admin/masterclass",
    meta: { ...(index7vDHnznT_8MI1pz_45GTKZlg6hYUt4OGshmOJ3SjRZP_8Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/masterclass/index.vue")
  },
  {
    name: "admin-notifications-log",
    path: "/admin/notifications/log",
    meta: { ...(log1lPkpIrYpyGEpYyyDQTBLdN375SKYFP2nPl16DePg9wMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/notifications/log.vue")
  },
  {
    name: "admin-security-scraping",
    path: "/admin/security/scraping",
    meta: { ...(scrapingPLrKIdjNbRfVsRKJlnf55w2n9W31JlsGaUBKMRlpgq8Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/security/scraping.vue")
  },
  {
    name: "admin-service-referrals",
    path: "/admin/service-referrals",
    meta: { ...(service_45referralsZKttKhiKw0OlEYNDM6fhCchLzpY_45iH4_458pMViVBIG64Meta || {}), ...{"middleware":["is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/service-referrals.vue")
  },
  {
    name: "am-service-orders",
    path: "/am/service-orders",
    meta: { ...(indexp7wxBYjwawSMsQ_45EA3gu5JHbvUkk_mQHUp5CJQzjPIwMeta || {}), ...{"middleware":["is-auth","is-account-manager"],"i18n":false} },
    component: () => import("/usr/src/app/pages/am/service-orders/index.vue")
  },
  {
    name: "developer-projects-id",
    path: "/developer/projects/:id()",
    meta: { ...(_91id_93o_68hyu2yfYqdd7fR4H1_wWiXEo4vzCKJ7ASJThsHkUMeta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/projects/[id].vue")
  },
  {
    name: "my-services-orders-id",
    path: "/my-services/orders/:id()",
    meta: { ...(_91id_93LjRlNeU8_45womFDz3E3JJAVKIsLb8pXG4Vo2tn2O7d3YMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/my-services/orders/[id].vue")
  },
  {
    name: "my-services-pay-token",
    path: "/my-services/pay/:token()",
    meta: { ...(_91token_93dbIF_45974JEHvn7pQV9beDt9zM3lrhaCJ7ozj7GkwMNYMeta || {}), ...{"middleware":["is-auth"],"i18n":false} },
    component: () => import("/usr/src/app/pages/my-services/pay/[token].vue")
  },
  {
    name: "a-handle-projectSlug",
    path: "/a/:handle()/:projectSlug()",
    meta: { ...(_91projectSlug_93eBRD5XwyY3S9hVpuz1r1tdPDT7wDmTLKK3aW82by2ooMeta || {}), ...{"i18n":false} },
    component: () => import("/usr/src/app/pages/a/[handle]/[projectSlug].vue")
  },
  {
    name: "admin-b2b-agencies",
    path: "/admin/b2b-agencies",
    meta: { ...(index7yE3ct0wOkGp6E5ItVQEucuZD7XEIwKG8fYQ_45PE9jxMMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/b2b-agencies/index.vue")
  },
  {
    name: "developer-projects",
    path: "/developer/projects",
    meta: { ...(indexWiQXcPS3ok1Q1Wb688J9DONnMKnV2iAKltnCoGjeHRYMeta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/projects/index.vue")
  },
  {
    name: "admin-notifications",
    path: "/admin/notifications",
    meta: { ...(indexIU8xSjCy1nJAWqGIUyJbWFLAoFqKzROqSiNeVMys9IgMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/notifications/index.vue")
  },
  {
    name: "admin-service-orders-id",
    path: "/admin/service-orders/:id()",
    meta: { ...(_91id_93StSXMwxmNMEUAnHBGtapfLUa1x7tIykaf9MUxQaIEO4Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/service-orders/[id].vue")
  },
  {
    name: "deals-register-consultant",
    path: "/deals/register/consultant",
    meta: { ...(deals_45register_45consultant9Vm21QFRyCVEeWxcoARZ9Siq8AAifnJ7NqCrgUUymkAMeta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register-consultant.vue")
  },
  {
    name: "deals-register-self-close",
    path: "/deals/register/self-close",
    meta: { ...(deals_45register_45self_45closeAke_ETW22JRpZYcPI3IyU3oKuhugpPps_lsxzQCIPhcMeta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register-self-close.vue")
  },
  {
    name: "property-hash-unit-id",
    path: "/property/:hash()/unit/:id()",
    meta: {"i18n":false},
    component: () => import("/usr/src/app/pages/property/[hash]/unit/[id].vue")
  },
  {
    name: "services-slug-submitted___en",
    path: "/services/:slug()/submitted",
    meta: { ...(submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submitted.vue")
  },
  {
    name: "services-slug-submitted___ar",
    path: "/ar/services/:slug()/submitted",
    meta: { ...(submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submitted.vue")
  },
  {
    name: "services-slug-submitted___he",
    path: "/he/services/:slug()/submitted",
    meta: { ...(submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submitted.vue")
  },
  {
    name: "services-slug-submitted___ru",
    path: "/ru/services/:slug()/submitted",
    meta: { ...(submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submitted.vue")
  },
  {
    name: "services-slug-submitted___zh",
    path: "/zh/services/:slug()/submitted",
    meta: { ...(submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submitted.vue")
  },
  {
    name: "services-slug-submitted___fr",
    path: "/fr/services/:slug()/submitted",
    meta: { ...(submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submitted.vue")
  },
  {
    name: "services-slug-submitted___de",
    path: "/de/services/:slug()/submitted",
    meta: { ...(submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submitted.vue")
  },
  {
    name: "services-slug-submitted___es",
    path: "/es/services/:slug()/submitted",
    meta: { ...(submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submitted.vue")
  },
  {
    name: "services-slug-submitted___it",
    path: "/it/services/:slug()/submitted",
    meta: { ...(submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submitted.vue")
  },
  {
    name: "services-slug-submitted___pt",
    path: "/pt/services/:slug()/submitted",
    meta: { ...(submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submitted.vue")
  },
  {
    name: "services-slug-submitted___tr",
    path: "/tr/services/:slug()/submitted",
    meta: { ...(submittedKZWyrgeivf8V_45RvoWbJ_jHJGQomE8suAd64_45d64qqFAMeta || {}), ...{"middleware":["is-agent"]} },
    component: () => import("/usr/src/app/pages/services/[slug]/submitted.vue")
  },
  {
    name: "admin-service-orders",
    path: "/admin/service-orders",
    meta: { ...(index5kdic0zCrm64Wpm5Ujx5v6Q9tw5lEPkNwKth5IqDfEEMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/service-orders/index.vue")
  },
  {
    name: "deals-register-spa-confirm",
    path: "/deals/register/spa-confirm",
    meta: { ...(deals_45register_45spa_45confirmcppE4UUl7f1umQppKzFakgDpV2tqa0kIDG36oA3nDB8Meta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register-spa-confirm.vue")
  },
  {
    name: "deals-register-spa-pending",
    path: "/deals/register/spa-pending",
    meta: { ...(deals_45register_45spa_45pendingwwrCpv8AYW8pDJoM7LqCS_457ppBoDVBZw1t_45wAGwWAp0Meta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register-spa-pending.vue")
  },
  {
    name: "admin-agent-referrals",
    path: "/admin/agent-referrals",
    meta: { ...(index_45AQLQIi5l8rwdOs4q40nuEg0VUPSCz62H8DAvlmy0o0Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/agent-referrals/index.vue")
  },
  {
    name: "admin-email-templates-key",
    path: "/admin/email-templates/:key()",
    meta: { ...(_91key_93gHriwPoQoV475LrXyy_eq3pUIYxuqogZI9CVicQD7_8Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/email-templates/[key].vue")
  },
  {
    name: "admin-email-templates",
    path: "/admin/email-templates",
    meta: { ...(indexsCiV5WBpnk9gwZzEr2q2qUW_93cIWCs3bnOkG_45V1Vk0Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/email-templates/index.vue")
  },
  {
    name: "deals-register-booking-form",
    path: "/deals/register/booking-form",
    meta: { ...(deals_45register_45booking_45formmVIgg5qQwmvUrDV_bxSWkT2UcVbF_45QT2XInQTMbAgU0Meta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register-booking-form.vue")
  },
  {
    name: "deals-register-token-upload",
    path: "/deals/register/token-upload",
    meta: { ...(deals_45register_45token_45uploadxgSC4ieGoCrvmQD4WVaUpwrdcRYvPMnwfBF1rEEuuk4Meta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register-token-upload.vue")
  },
  {
    name: "developer-presentations-new",
    path: "/developer/presentations/new",
    meta: { ...(newnaI4FQrLZb_btGD3hp7egqSncmgFPHC8vxegsTsP17gMeta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/presentations/new.vue")
  },
  {
    name: "projects-developer-slug___en",
    path: "/projects/:developer()/:slug()",
    meta: _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta || {},
    component: () => import("/usr/src/app/pages/projects/[developer]/[slug].vue")
  },
  {
    name: "projects-developer-slug___ar",
    path: "/ar/projects/:developer()/:slug()",
    meta: _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta || {},
    component: () => import("/usr/src/app/pages/projects/[developer]/[slug].vue")
  },
  {
    name: "projects-developer-slug___he",
    path: "/he/projects/:developer()/:slug()",
    meta: _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta || {},
    component: () => import("/usr/src/app/pages/projects/[developer]/[slug].vue")
  },
  {
    name: "projects-developer-slug___ru",
    path: "/ru/projects/:developer()/:slug()",
    meta: _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta || {},
    component: () => import("/usr/src/app/pages/projects/[developer]/[slug].vue")
  },
  {
    name: "projects-developer-slug___zh",
    path: "/zh/projects/:developer()/:slug()",
    meta: _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta || {},
    component: () => import("/usr/src/app/pages/projects/[developer]/[slug].vue")
  },
  {
    name: "projects-developer-slug___fr",
    path: "/fr/projects/:developer()/:slug()",
    meta: _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta || {},
    component: () => import("/usr/src/app/pages/projects/[developer]/[slug].vue")
  },
  {
    name: "projects-developer-slug___de",
    path: "/de/projects/:developer()/:slug()",
    meta: _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta || {},
    component: () => import("/usr/src/app/pages/projects/[developer]/[slug].vue")
  },
  {
    name: "projects-developer-slug___es",
    path: "/es/projects/:developer()/:slug()",
    meta: _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta || {},
    component: () => import("/usr/src/app/pages/projects/[developer]/[slug].vue")
  },
  {
    name: "projects-developer-slug___it",
    path: "/it/projects/:developer()/:slug()",
    meta: _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta || {},
    component: () => import("/usr/src/app/pages/projects/[developer]/[slug].vue")
  },
  {
    name: "projects-developer-slug___pt",
    path: "/pt/projects/:developer()/:slug()",
    meta: _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta || {},
    component: () => import("/usr/src/app/pages/projects/[developer]/[slug].vue")
  },
  {
    name: "projects-developer-slug___tr",
    path: "/tr/projects/:developer()/:slug()",
    meta: _91slug_93etZJUK6M2iDUXQIwnC_oXgtqhveSAeU6kUHZIVg6EAQMeta || {},
    component: () => import("/usr/src/app/pages/projects/[developer]/[slug].vue")
  },
  {
    name: "admin-commission-tiers",
    path: "/admin/commission-tiers",
    meta: { ...(indexFMzC08L04OW4_hbssEzkrJzLSHpnhQDLsEMd5lKcNHcMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/commission-tiers/index.vue")
  },
  {
    name: "admin-project-listings",
    path: "/admin/project-listings",
    meta: { ...(indexxg8mz0yFSDmAYdrq__45genIPfacdLK2EfLeA7fQN17REMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/project-listings/index.vue")
  },
  {
    name: "admin-service-catalogue-id",
    path: "/admin/service-catalogue/:id()",
    meta: { ...(_91id_932xam0cKcrAPZq_45KuiSSdZGbPa50oObiIi7vMVnaVOKUMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/service-catalogue/[id].vue")
  },
  {
    name: "developer-presentations-id",
    path: "/developer/presentations/:id()",
    meta: { ...(_91id_93LVoQ0nMUhlXVfQo_70tAAdTpGDRto5Wzr25V8f2MLaMMeta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/presentations/[id].vue")
  },
  {
    name: "admin-agent-withdrawals",
    path: "/admin/agent-withdrawals",
    meta: { ...(indexlC_Ma16XlxerbRQeGngI9nhbDTw1wJ7NQahj64r7GjQMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/agent-withdrawals/index.vue")
  },
  {
    name: "admin-points-of-interest-id",
    path: "/admin/points-of-interest/:id()",
    meta: { ...(_91id_93rfnhHlm8EI_45_45y68pQeghQ8biMVDapWQ9EwtwOA3Wn7UMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/points-of-interest/[id].vue")
  },
  {
    name: "admin-service-catalogue",
    path: "/admin/service-catalogue",
    meta: { ...(indexkIPFQeSJtk60FlDhL_TtrmyT_wfmhywNJ6c5HkH4JKoMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/service-catalogue/index.vue")
  },
  {
    name: "developer-presentations",
    path: "/developer/presentations",
    meta: { ...(index6vpa4mTNWkcudcnRJQeJ2FFhd4kg_TGNBCEpp3k33tUMeta || {}), ...{"middleware":["is-auth","is-developer-rep"],"i18n":false} },
    component: () => import("/usr/src/app/pages/developer/presentations/index.vue")
  },
  {
    name: "admin-deal-registrations",
    path: "/admin/deal-registrations",
    meta: { ...(indexckwSIJDnUWVmnxVboWbrLS2jif_45jQ6hff1kIMYwvkOsMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/deal-registrations/index.vue")
  },
  {
    name: "admin-developer-partners",
    path: "/admin/developer-partners",
    meta: { ...(index8LqVpus7kRHbIPbder5vb4uMB49SVn7_45WFG6pABF1EEMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    redirect: index8LqVpus7kRHbIPbder5vb4uMB49SVn7_45WFG6pABF1EEMeta?.redirect,
    component: () => import("/usr/src/app/pages/admin/developer-partners/index.vue")
  },
  {
    name: "admin-points-of-interest",
    path: "/admin/points-of-interest",
    meta: { ...(indexOSiHbOo4UvRKAzmlILr0Qa0IaySLFN_45eF4ACoxpe8E0Meta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/points-of-interest/index.vue")
  },
  {
    name: "deals-register-token-confirmed",
    path: "/deals/register/token-confirmed",
    meta: { ...(deals_45register_45token_45confirmedaYQVjt1H4Al_45efYJZo7kD5n3xteRAwWJ_45wkoVGdQqFYMeta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register-token-confirmed.vue")
  },
  {
    name: "admin-points-of-interest-create",
    path: "/admin/points-of-interest/create",
    meta: { ...(createvNpKohJR26couO2wn0bYY9ZF2yZMSshmmRYss4PluTQMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/points-of-interest/create.vue")
  },
  {
    name: "deals-register-booking-confirmed",
    path: "/deals/register/booking-confirmed",
    meta: { ...(deals_45register_45booking_45confirmeds97W_BFmh9NhLUOnRXitzt0m1CE4R9IbRWtPJK9NfVsMeta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register-booking-confirmed.vue")
  },
  {
    name: "admin-developer-partners-activity",
    path: "/admin/developer-partners/activity",
    meta: { ...(activityZ0DwXYSCk01BUBrV_zBsjGWPeQQf9ODZ4wSr71HmPzQMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/developer-partners/activity.vue")
  },
  {
    name: "admin-developer-partners-approvals",
    path: "/admin/developer-partners/approvals",
    meta: { ...(approvalsX1cYldj691PlFu0rkXHLC2tojdNE1eVb4C2LjXppwaMMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/developer-partners/approvals.vue")
  },
  {
    name: "admin-notifications-campaigns-id",
    path: "/admin/notifications/campaigns/:id()",
    meta: { ...(_91id_93cibkadBjkEt9rSNUQqZexEbOp7BcH2A_jEW3u3mN2eAMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/notifications/campaigns/[id].vue")
  },
  {
    name: "admin-notifications-campaigns",
    path: "/admin/notifications/campaigns",
    meta: { ...(indexrcBO0YAL9Esdjpwrw2rHy_XPPDbRvmG2UK0kSEMRaMcMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/notifications/campaigns/index.vue")
  },
  {
    name: "deals-register-commission-countdown",
    path: "/deals/register/commission-countdown",
    meta: { ...(deals_45register_45commission_45countdownRP7dicfJAqYoizFl0fzW1g4jWe7DAP5bUfbX7UWXiPIMeta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register-commission-countdown.vue")
  },
  {
    name: "deals-register-consultant-confirmed",
    path: "/deals/register/consultant-confirmed",
    meta: { ...(deals_45register_45consultant_45confirmed5tb0zeU9VaidWR3zBpSvTdX1Btta9hoEiLjhvlNlw1QMeta || {}), ...{"middleware":["is-agent","client-mode-guard"],"i18n":false} },
    component: () => import("/usr/src/app/pages/deals-register-consultant-confirmed.vue")
  },
  {
    name: "admin-developer-partners-permissions",
    path: "/admin/developer-partners/permissions",
    meta: { ...(permissions3pfR5AbMFB_ojFMVWBR1CkRT4583r79qzmsLPnGuYOEMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/developer-partners/permissions.vue")
  },
  {
    name: "admin-developer-partners-verification",
    path: "/admin/developer-partners/verification",
    meta: { ...(verification3PjI8M2exM28u4tj9jRYfdwAAJAbJMPSCSpcfpRPcLsMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/developer-partners/verification.vue")
  },
  {
    name: "admin-platform-account-managers",
    path: "/admin/platform-account-managers",
    meta: { ...(indexj8mefSSAlY_TvjvETOzftZ7wmo5enIXL2RNKlGJlxpcMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/platform-account-managers/index.vue")
  },
  {
    name: "admin-developer-partners-representatives",
    path: "/admin/developer-partners/representatives",
    meta: { ...(representativesKBBTDqvQc3BG9M5QVcOuEG3M6Rsfqia9lYs2DranvqQMeta || {}), ...{"middleware":["is-auth","is-admin"],"i18n":false} },
    component: () => import("/usr/src/app/pages/admin/developer-partners/representatives.vue")
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/en/optin",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/terms-of-use",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/privacy-notice",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  }
]